var _style, _symbol, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWireframeMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 1200",
    style: {
      enableBackground: "new 0 0 480 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.5;fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "dot",
    viewBox: "-4 -4 8 8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 0,
    cy: 0,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 0,
    cy: 0,
    r: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.09,631.94l-29.77,71.07c33.49,2.6,33.49,2.6,33.49,2.6l22.27-58.57L207.09,631.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "179.18,657.24 177.32,703.01 174.46,729.43 203.37,740.59 210.81,705.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "169.13,762.4 160.95,745.8 174.46,729.43  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.46,
    y1: 729.43,
    x2: 169.13,
    y2: 762.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.46,
    y1: 729.43,
    x2: 210.81,
    y2: 705.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.18,657.24c-6.14,11.53-28.65,59.28-28.65,59.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "150.53,716.52 177.32,703.01 117.41,688.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203.37,740.59l-29.4,19.35l-23.44-43.42l-33.12-28.02c0,0,60.65-30.88,61.77-31.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "117.41,688.5 129.69,754.36 160.95,745.8 203.37,740.59  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 129.69,
    y1: 754.36,
    x2: 169.13,
    y2: 762.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.46,
    y1: 729.43,
    x2: 129.69,
    y2: 754.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.53,
    y1: 716.52,
    x2: 136.02,
    y2: 764.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 136.02,
    y1: 764.41,
    x2: 160.95,
    y2: 745.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.9,
    y1: 774.45,
    x2: 160.95,
    y2: 745.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.9,
    y1: 774.45,
    x2: 169.13,
    y2: 762.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 160.95,
    y1: 786.36,
    x2: 173.97,
    y2: 759.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 195.55,
    y1: 777.43,
    x2: 160.95,
    y2: 786.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 188.85,
    y1: 787.85,
    x2: 160.95,
    y2: 786.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.76,
    y1: 807.94,
    x2: 160.95,
    y2: 786.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 199.27,
    y1: 794.92,
    x2: 160.95,
    y2: 786.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 147.37,
    y1: 825.43,
    x2: 160.95,
    y2: 786.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.23,
    y1: 809.8,
    x2: 146.9,
    y2: 774.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 136.02,
    y1: 793.8,
    x2: 160.95,
    y2: 786.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.13,
    y1: 762.4,
    x2: 127.46,
    y2: 769.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 129.69,
    y1: 754.36,
    x2: 127.46,
    y2: 769.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "127.46,769.36 136.02,793.8 136.02,764.41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "188.85,787.85 173.97,759.94 195.55,777.43 203.37,740.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "195.55,777.43 188.85,787.85 169.13,823.94 160.95,786.36  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 136.02,
    y1: 793.8,
    x2: 169.13,
    y2: 762.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 160.95,
    y1: 786.36,
    x2: 146.9,
    y2: 774.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 199.27,
    y1: 794.92,
    x2: 173.97,
    y2: 759.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 195.55,
    y1: 813.9,
    x2: 188.85,
    y2: 787.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.18,
    y1: 819.85,
    x2: 199.27,
    y2: 794.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 195.55,
    y1: 813.9,
    x2: 195.55,
    y2: 777.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.76,
    y1: 807.94,
    x2: 199.27,
    y2: 794.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 147.37,
    y1: 825.43,
    x2: 141.23,
    y2: 809.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 136.02,
    y1: 793.8,
    x2: 141.23,
    y2: 809.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 138.62,
    y1: 838.08,
    x2: 136.02,
    y2: 793.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 138.62,
    y1: 836.22,
    x2: 141.29,
    y2: 807.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 195.55,
    y1: 777.43,
    x2: 199.27,
    y2: 794.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.85,
    y1: 833.62,
    x2: 195.55,
    y2: 813.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.18,
    y1: 819.85,
    x2: 195.55,
    y2: 813.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.85,
    y1: 833.62,
    x2: 179.18,
    y2: 819.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.76,
    y1: 807.94,
    x2: 209.81,
    y2: 852.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 197.49,
    y1: 859.18,
    x2: 209.81,
    y2: 852.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 186.62,
    y1: 862.27,
    x2: 197.49,
    y2: 859.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 129.69,
    y1: 754.36,
    x2: 136.02,
    y2: 795.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 136.02,
    y1: 764.41,
    x2: 129.69,
    y2: 754.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 127.46,
    y1: 769.36,
    x2: 146.9,
    y2: 774.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 136.02,
    y1: 764.41,
    x2: 146.9,
    y2: 774.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.23,
    y1: 809.8,
    x2: 179.18,
    y2: 819.85
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "143.27,955.66 192.2,945.62 195.55,920.69 207.46,913.24 210.81,881.99 201.88,887.57  193.13,888.31 169.13,854.08 186.62,862.27 180.85,833.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "141.34,891.29 155.74,933.34 143.27,955.66  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.34,
    y1: 891.29,
    x2: 195.55,
    y2: 920.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 155.74,
    y1: 933.34,
    x2: 195.55,
    y2: 920.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 192.2,
    y1: 945.62,
    x2: 155.74,
    y2: 933.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.34,
    y1: 891.29,
    x2: 143.27,
    y2: 955.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 192.2,
    y1: 945.62,
    x2: 207.46,
    y2: 913.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 193.13,
    y1: 888.31,
    x2: 195.18,
    y2: 923.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 201.88,
    y1: 887.57,
    x2: 207.46,
    y2: 913.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 195.55,
    y1: 920.69,
    x2: 208.95,
    y2: 874.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.46,
    y1: 913.24,
    x2: 208.95,
    y2: 874.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 193.13,
    y1: 888.31,
    x2: 208.95,
    y2: 874.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 186.62,
    y1: 862.27,
    x2: 201.88,
    y2: 887.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 197.49,
    y1: 859.18,
    x2: 193.13,
    y2: 888.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.02,
    y1: 842.92,
    x2: 197.49,
    y2: 859.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 208.95,
    y1: 874.92,
    x2: 186.62,
    y2: 862.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 201.88,
    y1: 887.57,
    x2: 197.49,
    y2: 859.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 208.95,
    y1: 874.92,
    x2: 197.49,
    y2: 859.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 210.81,
    y1: 881.99,
    x2: 208.95,
    y2: 874.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 209.81,
    y1: 852.59,
    x2: 208.95,
    y2: 874.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.02,
    y1: 842.92,
    x2: 208.95,
    y2: 874.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 209.81,
    y1: 852.59,
    x2: 200.02,
    y2: 842.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.76,
    y1: 807.94,
    x2: 200.02,
    y2: 842.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 195.55,
    y1: 813.9,
    x2: 209.81,
    y2: 852.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 197.49,
    y1: 859.18,
    x2: 195.55,
    y2: 813.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.18,
    y1: 819.85,
    x2: 197.49,
    y2: 859.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.85,
    y1: 833.62,
    x2: 197.49,
    y2: 859.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 160.95,
    y1: 836.78,
    x2: 197.49,
    y2: 859.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.13,
    y1: 823.94,
    x2: 169.13,
    y2: 854.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.53,
    y1: 866.1,
    x2: 180.85,
    y2: 833.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.34,
    y1: 891.29,
    x2: 157.9,
    y2: 870.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 193.13,
    y1: 888.31,
    x2: 141.34,
    y2: 891.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.9,
    y1: 870.83,
    x2: 193.13,
    y2: 888.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.34,
    y1: 891.29,
    x2: 186.62,
    y2: 862.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 131.74,
    y1: 879.57,
    x2: 141.34,
    y2: 891.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.85,
    y1: 847.96,
    x2: 131.74,
    y2: 879.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 138.62,
    y1: 838.08,
    x2: 132.85,
    y2: 847.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 147.37,
    y1: 825.43,
    x2: 138.62,
    y2: 838.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.9,
    y1: 870.83,
    x2: 131.74,
    y2: 879.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.53,
    y1: 866.1,
    x2: 131.74,
    y2: 879.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.34,
    y1: 891.29,
    x2: 150.53,
    y2: 866.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 186.62,
    y1: 862.27,
    x2: 150.53,
    y2: 866.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.9,
    y1: 870.83,
    x2: 169.13,
    y2: 854.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.53,
    y1: 866.1,
    x2: 160.95,
    y2: 836.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.9,
    y1: 870.83,
    x2: 147.37,
    y2: 825.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 145.94,
    y1: 856.13,
    x2: 147.37,
    y2: 825.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 138.62,
    y1: 838.08,
    x2: 145.94,
    y2: 856.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.85,
    y1: 847.96,
    x2: 150.53,
    y2: 866.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.34,
    y1: 891.29,
    x2: 132.85,
    y2: 847.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 138.62,
    y1: 838.08,
    x2: 160.95,
    y2: 836.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 195.55,
    y1: 813.9,
    x2: 160.95,
    y2: 836.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 147.37,
    y1: 825.43,
    x2: 169.13,
    y2: 823.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 145.94,
    y1: 856.13,
    x2: 150.53,
    y2: 866.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 138.62,
    y1: 838.08,
    x2: 141.34,
    y2: 891.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 145.94,
    y1: 856.13,
    x2: 131.74,
    y2: 879.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 141.34,
    y1: 891.29,
    x2: 146.65,
    y2: 854.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.13,
    y1: 823.94,
    x2: 138.62,
    y2: 838.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 160.95,
    y1: 836.78,
    x2: 141.23,
    y2: 809.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 145.94,
    y1: 856.13,
    x2: 160.95,
    y2: 836.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.02,
    y1: 842.92,
    x2: 169.13,
    y2: 854.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.02,
    y1: 842.92,
    x2: 180.85,
    y2: 833.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 160.95,
    y1: 836.78,
    x2: 180.85,
    y2: 833.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 186.62,
    y1: 862.27,
    x2: 160.95,
    y2: 836.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.85,
    y1: 847.96,
    x2: 169.13,
    y2: 823.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.18,
    y1: 819.85,
    x2: 169.13,
    y2: 823.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.85,
    y1: 833.62,
    x2: 169.13,
    y2: 823.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 160.95,
    y1: 836.78,
    x2: 169.13,
    y2: 823.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.13,
    y1: 854.08,
    x2: 147.37,
    y2: 825.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.9,
    y1: 870.83,
    x2: 169.13,
    y2: 823.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.13,
    y1: 854.08,
    x2: 145.94,
    y2: 856.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.85,
    y1: 847.96,
    x2: 169.13,
    y2: 854.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 193.13,
    y1: 888.31,
    x2: 207.46,
    y2: 913.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.53,
    y1: 640.87,
    x2: 179.18,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.23,
    y1: 597.34,
    x2: 179.18,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.46,
    y1: 577.5,
    x2: 179.18,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.37,
    y1: 604.04,
    x2: 179.18,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 214.2,
    y1: 614.34,
    x2: 179.18,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.09,
    y1: 631.94,
    x2: 179.18,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 233.08,
    y1: 647.04,
    x2: 179.18,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "214.2,614.34 225.69,694.83 230.9,713.43 239.46,747.66 251.99,780.9 274.44,760.86 299.99,728.43  246.9,681.8 257.44,664.69 301.54,661.71 312.32,694.08 318.47,707.11 279.61,708.11 246.53,740.97 242.06,693.71 230.9,713.43  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 194.13,
    y1: 585.06,
    x2: 150.53,
    y2: 640.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.23,
    y1: 597.34,
    x2: 150.53,
    y2: 640.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.88,
    y1: 624.87,
    x2: 157.23,
    y2: 597.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 117.41,
    y1: 624.5,
    x2: 157.23,
    y2: 597.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 114.44,
    y1: 591.52,
    x2: 157.23,
    y2: 597.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.18,
    y1: 541.9,
    x2: 157.23,
    y2: 597.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 194.13,
    y1: 585.06,
    x2: 157.23,
    y2: 597.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.09,
    y1: 631.94,
    x2: 157.23,
    y2: 597.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.37,
    y1: 604.04,
    x2: 150.53,
    y2: 640.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.09,
    y1: 631.94,
    x2: 150.53,
    y2: 640.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 114.44,
    y1: 591.52,
    x2: 137.88,
    y2: 624.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 117.41,
    y1: 688.5,
    x2: 150.53,
    y2: 640.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.18,
    y1: 657.24,
    x2: 126.16,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 117.41,
    y1: 688.5,
    x2: 126.16,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 114.06,
    y1: 675.11,
    x2: 117.41,
    y2: 688.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 117.41,
    y1: 624.5,
    x2: 114.06,
    y2: 675.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 114.44,
    y1: 591.52,
    x2: 117.41,
    y2: 624.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.88,
    y1: 624.87,
    x2: 117.41,
    y2: 624.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 123.74,
    y1: 627.29,
    x2: 146.28,
    y2: 646.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.88,
    y1: 624.87,
    x2: 126.16,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 123.74,
    y1: 627.29,
    x2: 114.06,
    y2: 675.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 126.16,
    y1: 657.24,
    x2: 117.41,
    y2: 624.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.02,
    y1: 662.08,
    x2: 123.74,
    y2: 627.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 114.06,
    y1: 675.11,
    x2: 132.02,
    y2: 662.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 126.16,
    y1: 657.24,
    x2: 114.06,
    y2: 675.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.53,
    y1: 640.87,
    x2: 126.16,
    y2: 657.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.88,
    y1: 624.87,
    x2: 150.53,
    y2: 640.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.18,
    y1: 657.24,
    x2: 137.88,
    y2: 624.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 123.74,
    y1: 627.29,
    x2: 150.53,
    y2: 640.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.02,
    y1: 662.08,
    x2: 150.53,
    y2: 640.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 114.44,
    y1: 591.52,
    x2: 123.74,
    y2: 627.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.04,
    y1: 577.5,
    x2: 123.74,
    y2: 627.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 114.44,
    y1: 591.52,
    x2: 122.04,
    y2: 577.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.02,
    y1: 516.22,
    x2: 114.44,
    y2: 591.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.04,
    y1: 577.5,
    x2: 132.02,
    y2: 516.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.99,
    y1: 546.86,
    x2: 122.04,
    y2: 577.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 144.2,
    y1: 577.25,
    x2: 137.99,
    y2: 546.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 168.2,
    y1: 536.31,
    x2: 144.2,
    y2: 577.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.46,
    y1: 577.5,
    x2: 168.2,
    y2: 536.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.04,
    y1: 577.5,
    x2: 144.2,
    y2: 577.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.46,
    y1: 577.5,
    x2: 144.2,
    y2: 577.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 149.04,
    y1: 533.71,
    x2: 157.23,
    y2: 597.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 168.2,
    y1: 536.31,
    x2: 137.99,
    y2: 546.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.18,
    y1: 541.9,
    x2: 168.2,
    y2: 536.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 149.04,
    y1: 533.71,
    x2: 168.2,
    y2: 536.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170.83,
    y1: 503.08,
    x2: 168.2,
    y2: 536.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.99,
    y1: 546.86,
    x2: 174.46,
    y2: 577.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170.83,
    y1: 503.08,
    x2: 149.04,
    y2: 533.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.99,
    y1: 546.86,
    x2: 149.04,
    y2: 533.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 134.24,
    y1: 500.08,
    x2: 149.04,
    y2: 533.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.99,
    y1: 546.86,
    x2: 132.02,
    y2: 516.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 134.24,
    y1: 500.08,
    x2: 137.99,
    y2: 546.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.74,
    y1: 501.34,
    x2: 170.83,
    y2: 503.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 168.2,
    y1: 536.31,
    x2: 203.74,
    y2: 501.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 134.24,
    y1: 500.08,
    x2: 170.83,
    y2: 503.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.02,
    y1: 516.22,
    x2: 134.24,
    y2: 500.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 175.46,
    y1: 562.05,
    x2: 144.2,
    y2: 577.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 181.3,
    y1: 556.78,
    x2: 168.2,
    y2: 536.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.99,
    y1: 546.86,
    x2: 181.3,
    y2: 556.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.74,
    y1: 501.34,
    x2: 181.3,
    y2: 556.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 143.27,
    y1: 955.66,
    x2: 152.58,
    y2: 991.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.63,
    y1: 968.31,
    x2: 152.58,
    y2: 991.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.53,
    y1: 1017.8,
    x2: 152.58,
    y2: 991.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 192.2,
    y1: 945.62,
    x2: 189.23,
    y2: 988.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190.44,
    y1: 1016.31,
    x2: 189.23,
    y2: 988.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190.71,
    y1: 1046.08,
    x2: 190.44,
    y2: 1016.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 197.78,
    y1: 1090.17,
    x2: 190.71,
    y2: 1046.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 192.02,
    y1: 1090.36,
    x2: 190.71,
    y2: 1046.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 191.37,
    y1: 1105.24,
    x2: 197.78,
    y2: 1090.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 192.02,
    y1: 1090.36,
    x2: 191.37,
    y2: 1105.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 1057.62,
    x2: 197.78,
    y2: 1090.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 192.02,
    y1: 1090.36,
    x2: 184.58,
    y2: 1057.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190.71,
    y1: 1046.08,
    x2: 184.58,
    y2: 1057.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 1031.2,
    x2: 190.71,
    y2: 1046.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190.44,
    y1: 1016.31,
    x2: 184.58,
    y2: 1031.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170.9,
    y1: 983.57,
    x2: 190.44,
    y2: 1016.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 991.38,
    x2: 163.42,
    y2: 1006.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.63,
    y1: 968.31,
    x2: 163.42,
    y2: 1006.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170.9,
    y1: 983.57,
    x2: 163.42,
    y2: 1006.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.53,
    y1: 1017.8,
    x2: 170.9,
    y2: 983.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 984.31,
    x2: 192.2,
    y2: 945.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.63,
    y1: 968.31,
    x2: 170.9,
    y2: 983.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 143.27,
    y1: 955.66,
    x2: 152.63,
    y2: 968.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 189.23,
    y1: 988.03,
    x2: 152.63,
    y2: 968.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 143.27,
    y1: 955.66,
    x2: 184.58,
    y2: 984.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.58,
    y1: 991.76,
    x2: 170.9,
    y2: 983.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 991.38,
    x2: 152.58,
    y2: 991.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170.9,
    y1: 983.57,
    x2: 184.58,
    y2: 991.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 984.31,
    x2: 170.9,
    y2: 983.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.67,
    y1: 1021.9,
    x2: 184.58,
    y2: 991.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 189.23,
    y1: 988.03,
    x2: 180.67,
    y2: 1021.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190.44,
    y1: 1016.31,
    x2: 155.74,
    y2: 1014.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 163.42,
    y1: 1006.3,
    x2: 155.74,
    y2: 1014.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.58,
    y1: 991.76,
    x2: 163.42,
    y2: 1006.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 991.38,
    x2: 190.44,
    y2: 1016.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 159.25,
    y1: 1034.43,
    x2: 175.64,
    y2: 1054.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 1057.62,
    x2: 175.64,
    y2: 1054.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190.71,
    y1: 1046.08,
    x2: 175.64,
    y2: 1054.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 1031.2,
    x2: 148.23,
    y2: 1049.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.67,
    y1: 1021.9,
    x2: 159.25,
    y2: 1034.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 155.74,
    y1: 1014.45,
    x2: 184.58,
    y2: 1031.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.67,
    y1: 1021.9,
    x2: 150.53,
    y2: 1017.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 163.42,
    y1: 1006.3,
    x2: 159.25,
    y2: 1034.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 155.74,
    y1: 1014.45,
    x2: 159.25,
    y2: 1034.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.53,
    y1: 1017.8,
    x2: 159.25,
    y2: 1034.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 144.82,
    y1: 1044.35,
    x2: 155.74,
    y2: 1014.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.53,
    y1: 1017.8,
    x2: 148.23,
    y2: 1049.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 159.25,
    y1: 1034.43,
    x2: 144.82,
    y2: 1044.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 159.25,
    y1: 1034.43,
    x2: 148.23,
    y2: 1049.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.99,
    y1: 1055.94,
    x2: 159.25,
    y2: 1034.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 175.64,
    y1: 1054.27,
    x2: 144.82,
    y2: 1044.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190.71,
    y1: 1046.08,
    x2: 148.23,
    y2: 1049.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.67,
    y1: 1021.9,
    x2: 175.64,
    y2: 1054.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 1057.62,
    x2: 180.67,
    y2: 1021.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 1031.2,
    x2: 184.58,
    y2: 1057.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.49,
    y1: 1089.99,
    x2: 184.58,
    y2: 1057.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 166.4,
    y1: 1097.24,
    x2: 175.64,
    y2: 1054.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.49,
    y1: 1089.99,
    x2: 175.64,
    y2: 1054.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 166.4,
    y1: 1097.24,
    x2: 184.58,
    y2: 1057.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.99,
    y1: 1055.94,
    x2: 166.4,
    y2: 1097.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.49,
    y1: 1089.99,
    x2: 150.99,
    y2: 1055.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 175.64,
    y1: 1054.27,
    x2: 150.99,
    y2: 1055.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.58,
    y1: 1057.62,
    x2: 150.99,
    y2: 1055.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 129.69,
    y1: 1072.13,
    x2: 145.71,
    y2: 1041.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 148.23,
    y1: 1049.38,
    x2: 129.69,
    y2: 1072.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.99,
    y1: 1055.94,
    x2: 129.69,
    y2: 1072.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.5,
    y1: 1106.87,
    x2: 129.69,
    y2: 1072.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 157.49,
    y1: 1089.99,
    x2: 129.69,
    y2: 1072.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.62,
    y1: 1087.76,
    x2: 157.49,
    y2: 1089.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.5,
    y1: 1106.87,
    x2: 157.49,
    y2: 1089.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 135.74,
    y1: 1120.87,
    x2: 157.49,
    y2: 1089.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 166.4,
    y1: 1097.24,
    x2: 157.49,
    y2: 1089.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.16,
    y1: 1097.24,
    x2: 191.37,
    y2: 1105.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.5,
    y1: 1106.87,
    x2: 191.37,
    y2: 1105.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 135.74,
    y1: 1120.87,
    x2: 191.37,
    y2: 1105.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.62,
    y1: 1087.76,
    x2: 135.74,
    y2: 1120.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.25,
    y1: 1107.85,
    x2: 135.74,
    y2: 1120.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 103.65,
    y1: 1101.24,
    x2: 115.18,
    y2: 1114.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.62,
    y1: 1087.76,
    x2: 103.65,
    y2: 1101.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 105.13,
    y1: 1114.36,
    x2: 122.62,
    y2: 1087.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 115.18,
    y1: 1114.36,
    x2: 122.62,
    y2: 1087.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.25,
    y1: 1107.85,
    x2: 122.62,
    y2: 1087.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 129.69,
    y1: 1072.13,
    x2: 122.25,
    y2: 1107.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 103.65,
    y1: 1101.24,
    x2: 129.69,
    y2: 1072.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.62,
    y1: 1087.76,
    x2: 129.69,
    y2: 1072.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 104.02,
    y1: 1127.2,
    x2: 105.13,
    y2: 1114.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 103.65,
    y1: 1101.24,
    x2: 105.13,
    y2: 1114.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 91.37,
    y1: 1118.64,
    x2: 103.65,
    y2: 1101.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.25,
    y1: 1107.85,
    x2: 152.5,
    y2: 1106.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 115.18,
    y1: 1114.36,
    x2: 152.5,
    y2: 1106.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 135.74,
    y1: 1120.87,
    x2: 152.5,
    y2: 1106.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 115.18,
    y1: 1114.36,
    x2: 135.74,
    y2: 1120.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 103.65,
    y1: 1101.24,
    x2: 122.25,
    y2: 1107.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.16,
    y1: 1097.24,
    x2: 192.02,
    y2: 1090.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.5,
    y1: 1106.87,
    x2: 197.78,
    y2: 1090.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 166.4,
    y1: 1097.24,
    x2: 174.16,
    y2: 1097.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.5,
    y1: 1106.87,
    x2: 166.4,
    y2: 1097.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110.16,
    y1: 1130.92,
    x2: 135.74,
    y2: 1120.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 94.34,
    y1: 1122.36,
    x2: 135.74,
    y2: 1120.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 105.13,
    y1: 1114.36,
    x2: 91.37,
    y2: 1118.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 115.18,
    y1: 1114.36,
    x2: 105.13,
    y2: 1114.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110.16,
    y1: 1130.92,
    x2: 122.25,
    y2: 1107.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 163.42,
    y1: 1006.3,
    x2: 180.67,
    y2: 1021.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110.16,
    y1: 1130.92,
    x2: 115.18,
    y2: 1114.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 104.02,
    y1: 1127.2,
    x2: 115.18,
    y2: 1114.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 105.13,
    y1: 1114.36,
    x2: 110.16,
    y2: 1130.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 94.34,
    y1: 1122.36,
    x2: 105.13,
    y2: 1114.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258.44,1153.24c0.37-1.12,22.33-2.23,22.33-2.23h31.26l15.26-5.21l6.33-12.65l7.44-5.58l1-9.19l-2.49-46.26 l0.49-35.35l1-52.84h-30.88l15.74,30.15l-1.98,23.99l0.74,24.37l-19.35,18.6l20.47,16.19l8.19,12.7l-6.58,11.84l1,10.63 l-29.65-7.19l-10.91-17.42l6.7-18.93v-20.65l8.56-31.81l-0.42-19.49l9.4-8.49l-17.17-34.72l7.81-11.72l39.33-19.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 327.27,
    y1: 1145.8,
    x2: 298.74,
    y2: 1125.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.02,
    y1: 1151.01,
    x2: 285.23,
    y2: 1139.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.74,
    y1: 1110.27,
    x2: 270.34,
    y2: 1124.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.02,
    y1: 1151.01,
    x2: 270.34,
    y2: 1124.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 258.44,
    y1: 1147.66,
    x2: 270.34,
    y2: 1124.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 280.76,
    y1: 1151.01,
    x2: 270.34,
    y2: 1124.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 267.74,
    y1: 1135.94,
    x2: 285.23,
    y2: 1139.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.34,
    y1: 1124.22,
    x2: 285.23,
    y2: 1139.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 280.76,
    y1: 1151.01,
    x2: 267.74,
    y2: 1135.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 258.44,
    y1: 1153.24,
    x2: 267.74,
    y2: 1135.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 285.23,
    y1: 1139.1,
    x2: 258.44,
    y2: 1153.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 258.44,
    y1: 1147.66,
    x2: 285.23,
    y2: 1139.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.34,
    y1: 1124.22,
    x2: 267.74,
    y2: 1135.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 258.44,
    y1: 1147.66,
    x2: 258.44,
    y2: 1153.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.74,
    y1: 1110.27,
    x2: 312.02,
    y2: 1151.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 319.46,
    y1: 1110.27,
    x2: 342.04,
    y2: 1118.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.78,
    y1: 1124.6,
    x2: 341.04,
    y2: 1127.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.39,
    y1: 1132.41,
    x2: 312.02,
    y2: 1151.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 327.27,
    y1: 1145.8,
    x2: 328.39,
    y2: 1132.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.78,
    y1: 1124.6,
    x2: 327.27,
    y2: 1145.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.39,
    y1: 1132.41,
    x2: 333.6,
    y2: 1133.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 327.39,
    y1: 1121.78,
    x2: 342.04,
    y2: 1118.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.39,
    y1: 1132.41,
    x2: 342.04,
    y2: 1118.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 325.78,
    y1: 1097.24,
    x2: 327.39,
    y2: 1121.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.78,
    y1: 1124.6,
    x2: 325.78,
    y2: 1097.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 327.39,
    y1: 1121.78,
    x2: 319.46,
    y2: 1110.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.78,
    y1: 1124.6,
    x2: 327.39,
    y2: 1121.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.97,
    y1: 1109.94,
    x2: 333.6,
    y2: 1133.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.04,
    y1: 1118.38,
    x2: 333.97,
    y2: 1109.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 325.78,
    y1: 1097.24,
    x2: 298.74,
    y2: 1125.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 305.88,
    y1: 1105.43,
    x2: 312.78,
    y2: 1124.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.74,
    y1: 1110.27,
    x2: 305.88,
    y2: 1105.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 339.55,
    y1: 1072.13,
    x2: 325.78,
    y2: 1097.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 323.92,
    y1: 1038.08,
    x2: 339.55,
    y2: 1072.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 324.67,
    y1: 1062.45,
    x2: 339.55,
    y2: 1072.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.74,
    y1: 1110.27,
    x2: 298.74,
    y2: 1125.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 294.53,
    y1: 1088.87,
    x2: 298.74,
    y2: 1125.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 287.83,
    y1: 1107.8,
    x2: 267.74,
    y2: 1135.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.34,
    y1: 1124.22,
    x2: 287.83,
    y2: 1107.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 294.53,
    y1: 1068.22,
    x2: 287.83,
    y2: 1107.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 294.53,
    y1: 1088.87,
    x2: 305.32,
    y2: 1081.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.11,
    y1: 1076.43,
    x2: 305.88,
    y2: 1105.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 305.32,
    y1: 1081.06,
    x2: 305.88,
    y2: 1105.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 294.53,
    y1: 1088.87,
    x2: 305.88,
    y2: 1105.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 305.32,
    y1: 1081.06,
    x2: 319.46,
    y2: 1110.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 325.78,
    y1: 1097.24,
    x2: 305.88,
    y2: 1105.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 287.83,
    y1: 1107.8,
    x2: 325.78,
    y2: 1097.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 324.67,
    y1: 1062.45,
    x2: 325.78,
    y2: 1097.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.11,
    y1: 1076.43,
    x2: 325.78,
    y2: 1097.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.97,
    y1: 1109.94,
    x2: 333.11,
    y2: 1076.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.04,
    y1: 1118.38,
    x2: 333.11,
    y2: 1076.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.74,
    y1: 1110.27,
    x2: 305.32,
    y2: 1081.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 301.53,
    y1: 1074.99,
    x2: 305.32,
    y2: 1081.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 294.53,
    y1: 1088.87,
    x2: 301.53,
    y2: 1074.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.11,
    y1: 1076.43,
    x2: 305.32,
    y2: 1081.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 339.55,
    y1: 1072.13,
    x2: 301.53,
    y2: 1074.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 324.67,
    y1: 1062.45,
    x2: 333.11,
    y2: 1076.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 340.04,
    y1: 1036.78,
    x2: 324.67,
    y2: 1062.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 305.88,
    y1: 1051.85,
    x2: 322.92,
    y2: 1065.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 294.53,
    y1: 1068.22,
    x2: 322.92,
    y2: 1065.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 301.53,
    y1: 1074.99,
    x2: 322.92,
    y2: 1065.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 339.55,
    y1: 1072.13,
    x2: 322.92,
    y2: 1065.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 303.09,
    y1: 1036.41,
    x2: 322.92,
    y2: 1065.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 323.92,
    y1: 1038.08,
    x2: 301.53,
    y2: 1074.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 305.88,
    y1: 1051.85,
    x2: 301.53,
    y2: 1074.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 303.09,
    y1: 1036.41,
    x2: 301.53,
    y2: 1074.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 305.88,
    y1: 1051.85,
    x2: 294.53,
    y2: 1068.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 301.53,
    y1: 1074.99,
    x2: 294.53,
    y2: 1068.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 340.04,
    y1: 1036.78,
    x2: 305.88,
    y2: 1051.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 323.92,
    y1: 1038.08,
    x2: 305.88,
    y2: 1051.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 340.04,
    y1: 1036.78,
    x2: 323.92,
    y2: 1038.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 303.09,
    y1: 1036.41,
    x2: 323.92,
    y2: 1038.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.07,
    y1: 1008.43,
    x2: 323.92,
    y2: 1038.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 325.9,
    y1: 1014.1,
    x2: 303.09,
    y2: 1036.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 340.04,
    y1: 1036.78,
    x2: 325.9,
    y2: 1014.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 302.67,
    y1: 1016.92,
    x2: 323.92,
    y2: 1038.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 340.04,
    y1: 1036.78,
    x2: 302.67,
    y2: 1016.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.07,
    y1: 1008.43,
    x2: 303.09,
    y2: 1036.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 305.88,
    y1: 1051.85,
    x2: 312.07,
    y2: 1008.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 340.04,
    y1: 1036.78,
    x2: 312.07,
    y2: 1008.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 325.9,
    y1: 1014.1,
    x2: 302.67,
    y2: 1016.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "255.46,817.62 268.48,817.62 280.02,812.9 321.35,793.8 327.64,813.9 341.04,837.43 354.44,868.97  354.44,885.43 344.39,893.08 330.25,899.41 322.96,933.34 290.92,955.66 285.23,905.99 308.97,883.1 311.27,849.86 296.76,876.78  268.48,864.69 279.27,857.16 277.04,849.52 314.28,837.43 299.09,793.8 317.99,767.01  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 341.04,
    y1: 983.94,
    x2: 325.9,
    y2: 1014.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.07,
    y1: 1008.43,
    x2: 341.04,
    y2: 983.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.04,
    y1: 942.01,
    x2: 341.04,
    y2: 983.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 310.16,
    y1: 983.94,
    x2: 342.04,
    y2: 942.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 294.9,
    y1: 973.71,
    x2: 342.04,
    y2: 942.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 310.16,
    y1: 983.94,
    x2: 294.9,
    y2: 973.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 302.67,
    y1: 1016.92,
    x2: 310.16,
    y2: 983.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.07,
    y1: 1008.43,
    x2: 310.16,
    y2: 983.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 322.96,
    y1: 933.34,
    x2: 310.16,
    y2: 983.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 290.92,
    y1: 955.66,
    x2: 294.9,
    y2: 973.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 302.67,
    y1: 1016.92,
    x2: 294.9,
    y2: 973.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 341.04,
    y1: 983.94,
    x2: 294.9,
    y2: 973.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 302.71,
    y1: 961.99,
    x2: 341.04,
    y2: 983.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 290.92,
    y1: 955.66,
    x2: 302.71,
    y2: 961.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 310.16,
    y1: 983.94,
    x2: 290.92,
    y2: 955.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 302.71,
    y1: 961.99,
    x2: 310.16,
    y2: 983.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 322.96,
    y1: 933.34,
    x2: 341.04,
    y2: 983.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.04,
    y1: 942.01,
    x2: 322.96,
    y2: 933.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 285.23,
    y1: 905.99,
    x2: 322.96,
    y2: 933.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 335.71,
    y1: 950.08,
    x2: 341.04,
    y2: 985.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 290.92,
    y1: 955.66,
    x2: 335.71,
    y2: 950.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 322.96,
    y1: 933.34,
    x2: 335.71,
    y2: 950.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.04,
    y1: 942.01,
    x2: 290.92,
    y2: 955.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 325.23,
    y1: 915.1,
    x2: 302.71,
    y2: 961.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.04,
    y1: 942.01,
    x2: 325.23,
    y2: 915.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.97,
    y1: 883.1,
    x2: 322.96,
    y2: 933.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 296.76,
    y1: 876.78,
    x2: 325.23,
    y2: 915.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.97,
    y1: 883.1,
    x2: 330.25,
    y2: 899.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 285.23,
    y1: 905.99,
    x2: 330.25,
    y2: 899.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.27,
    y1: 849.86,
    x2: 330.25,
    y2: 899.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 344.39,
    y1: 893.08,
    x2: 308.97,
    y2: 883.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 354.44,
    y1: 885.43,
    x2: 308.97,
    y2: 883.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 327.64,
    y1: 813.9,
    x2: 299.09,
    y2: 793.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 314.28,
    y1: 837.43,
    x2: 327.64,
    y2: 813.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 341.04,
    y1: 837.43,
    x2: 314.28,
    y2: 837.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.46,
    y1: 817.62,
    x2: 277.04,
    y2: 849.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.48,
    y1: 864.69,
    x2: 255.46,
    y2: 817.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 285.23,
    y1: 905.99,
    x2: 268.48,
    y2: 864.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.48,
    y1: 817.62,
    x2: 268.48,
    y2: 864.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 279.27,
    y1: 857.16,
    x2: 285.48,
    y2: 908.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 314.28,
    y1: 837.43,
    x2: 296.76,
    y2: 876.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 341.04,
    y1: 837.43,
    x2: 311.27,
    y2: 849.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 301.54,
    y1: 661.71,
    x2: 279.61,
    y2: 708.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.71,
    y1: 739.36,
    x2: 279.61,
    y2: 708.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 246.53,
    y1: 740.97,
    x2: 270.71,
    y2: 739.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 239.46,
    y1: 747.66,
    x2: 274.44,
    y2: 760.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 317.99,
    y1: 767.01,
    x2: 318.47,
    y2: 707.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.71,
    y1: 739.36,
    x2: 318.47,
    y2: 707.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.99,
    y1: 728.43,
    x2: 230.9,
    y2: 713.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 242.06,
    y1: 693.71,
    x2: 270.71,
    y2: 739.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 279.61,
    y1: 708.11,
    x2: 242.06,
    y2: 693.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 225.69,
    y1: 694.83,
    x2: 242.06,
    y2: 693.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 246.9,
    y1: 681.8,
    x2: 225.69,
    y2: 694.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 242.06,
    y1: 693.71,
    x2: 246.9,
    y2: 681.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.32,
    y1: 694.08,
    x2: 246.9,
    y2: 681.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 301.54,
    y1: 661.71,
    x2: 246.9,
    y2: 681.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 257.44,
    y1: 664.69,
    x2: 312.32,
    y2: 694.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.99,
    y1: 728.43,
    x2: 312.32,
    y2: 694.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "317.99,767.01 298.82,774.82 284.88,782.9 280.02,812.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.99,
    y1: 728.43,
    x2: 298.82,
    y2: 774.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 317.99,
    y1: 767.01,
    x2: 274.44,
    y2: 760.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 267.5,
    y1: 800.01,
    x2: 255.46,
    y2: 817.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 251.99,
    y1: 780.9,
    x2: 255.46,
    y2: 817.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.48,
    y1: 817.62,
    x2: 251.99,
    y2: 780.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 267.5,
    y1: 800.01,
    x2: 251.99,
    y2: 780.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 274.44,
    y1: 760.86,
    x2: 267.5,
    y2: 800.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 284.88,
    y1: 782.9,
    x2: 267.5,
    y2: 800.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.48,
    y1: 817.62,
    x2: 267.5,
    y2: 800.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 284.88,
    y1: 782.9,
    x2: 268.48,
    y2: 817.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.09,
    y1: 793.8,
    x2: 284.88,
    y2: 782.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 280.02,
    y1: 812.9,
    x2: 299.09,
    y2: 793.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 321.35,
    y1: 793.8,
    x2: 298.82,
    y2: 774.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.71,
    y1: 739.36,
    x2: 284.88,
    y2: 782.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 298.82,
    y1: 774.82,
    x2: 251.99,
    y2: 780.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 317.99,
    y1: 767.01,
    x2: 267.5,
    y2: 800.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.71,
    y1: 739.36,
    x2: 299.09,
    y2: 793.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 314.28,
    y1: 837.43,
    x2: 298.82,
    y2: 774.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 327.64,
    y1: 813.9,
    x2: 298.82,
    y2: 774.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 284.88,
    y1: 782.9,
    x2: 321.35,
    y2: 793.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.09,
    y1: 793.8,
    x2: 321.35,
    y2: 793.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.71,
    y1: 739.36,
    x2: 270.71,
    y2: 739.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 317.99,
    y1: 767.01,
    x2: 270.71,
    y2: 739.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 317.99,
    y1: 767.01,
    x2: 321.35,
    y2: 793.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 274.44,
    y1: 760.86,
    x2: 298.82,
    y2: 774.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.9,
    y1: 713.43,
    x2: 246.53,
    y2: 740.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 239.46,
    y1: 747.66,
    x2: 246.53,
    y2: 740.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 280.02,
    y1: 812.9,
    x2: 277.04,
    y2: 849.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.48,
    y1: 864.69,
    x2: 280.02,
    y2: 812.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 277.04,
    y1: 849.52,
    x2: 268.48,
    y2: 815.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.27,
    y1: 849.86,
    x2: 280.02,
    y2: 812.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 314.28,
    y1: 837.43,
    x2: 280.02,
    y2: 812.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 344.39,
    y1: 893.08,
    x2: 342.04,
    y2: 942.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 330.25,
    y1: 899.41,
    x2: 335.71,
    y2: 950.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 354.44,
    y1: 885.43,
    x2: 342.04,
    y2: 942.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.63,
    y1: 833.62,
    x2: 311.27,
    y2: 849.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.09,
    y1: 793.8,
    x2: 333.63,
    y2: 833.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 280.02,
    y1: 812.9,
    x2: 333.63,
    y2: 833.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 327.64,
    y1: 813.9,
    x2: 280.02,
    y2: 812.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.27,
    y1: 849.86,
    x2: 268.48,
    y2: 864.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 279.27,
    y1: 857.16,
    x2: 311.27,
    y2: 849.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 344.76,
    y1: 856.13,
    x2: 314.28,
    y2: 837.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 346.62,
    y1: 864.69,
    x2: 311.27,
    y2: 849.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.97,
    y1: 883.1,
    x2: 346.62,
    y2: 864.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 296.76,
    y1: 876.78,
    x2: 344.76,
    y2: 856.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.27,
    y1: 849.86,
    x2: 354.44,
    y2: 885.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 346.62,
    y1: 864.69,
    x2: 330.25,
    y2: 899.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.63,
    y1: 833.62,
    x2: 344.76,
    y2: 856.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 354.44,
    y1: 885.43,
    x2: 346.62,
    y2: 864.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 325.23,
    y1: 915.1,
    x2: 344.39,
    y2: 893.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 354.44,
    y1: 868.97,
    x2: 344.39,
    y2: 893.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 346.62,
    y1: 864.69,
    x2: 344.39,
    y2: 893.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 344.76,
    y1: 856.13,
    x2: 346.62,
    y2: 864.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 354.44,
    y1: 868.97,
    x2: 344.76,
    y2: 856.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 346.62,
    y1: 864.69,
    x2: 354.44,
    y2: 868.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 341.04,
    y1: 837.43,
    x2: 344.76,
    y2: 856.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 296.76,
    y1: 876.78,
    x2: 275.84,
    y2: 847.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 279.27,
    y1: 857.16,
    x2: 308.97,
    y2: 883.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "299.99,728.43 301.54,661.71 318.47,644.59 320.95,627.29 316.43,597.71 316.43,561.68  318.23,541.59 314.62,489.06 295.59,513.25 308.27,527.01 283.37,526.27 256.39,525.15 236.3,526.64 209.81,528.06 224.2,548.97  248.76,546.55 269.6,546.55 296.76,548.59 279.61,593.43 244.48,575.38 253.6,565.52 236.3,569.62 205.23,565.52 196.85,575.38  194.13,585.06 144.2,577.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "257.44,664.69 270.69,628.18 312.35,626.61 299.41,591.52 292.67,605.9 259.18,606.27  254.71,586.92 235.3,606.19 241.32,612.97 225.32,616.87 227.92,606.01 215.53,606.52 203.37,604.04 157.23,597.34  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.43,
    y1: 597.71,
    x2: 292.67,
    y2: 605.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.41,
    y1: 591.52,
    x2: 320.95,
    y2: 627.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.43,
    y1: 597.71,
    x2: 312.35,
    y2: 626.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 301.54,
    y1: 661.71,
    x2: 312.35,
    y2: 626.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 318.47,
    y1: 644.59,
    x2: 292.67,
    y2: 605.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 301.54,
    y1: 661.71,
    x2: 320.95,
    y2: 627.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 257.44,
    y1: 664.69,
    x2: 312.35,
    y2: 626.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 301.54,
    y1: 661.71,
    x2: 270.69,
    y2: 628.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 318.47,
    y1: 644.59,
    x2: 312.32,
    y2: 694.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 318.47,
    y1: 707.11,
    x2: 318.47,
    y2: 644.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.35,
    y1: 626.61,
    x2: 312.32,
    y2: 694.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.41,
    y1: 591.52,
    x2: 301.54,
    y2: 661.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 292.67,
    y1: 605.9,
    x2: 301.54,
    y2: 661.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.43,
    y1: 561.68,
    x2: 299.41,
    y2: 591.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.69,
    y1: 628.18,
    x2: 299.41,
    y2: 591.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 233.08,
    y1: 647.04,
    x2: 225.69,
    y2: 694.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.9,
    y1: 713.43,
    x2: 233.08,
    y2: 647.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 246.9,
    y1: 681.8,
    x2: 233.08,
    y2: 647.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 241.32,
    y1: 612.97,
    x2: 246.9,
    y2: 681.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 257.44,
    y1: 664.69,
    x2: 233.08,
    y2: 647.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 241.32,
    y1: 612.97,
    x2: 233.08,
    y2: 647.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 225.32,
    y1: 616.87,
    x2: 233.08,
    y2: 647.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 214.2,
    y1: 614.34,
    x2: 233.08,
    y2: 647.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.37,
    y1: 604.04,
    x2: 233.08,
    y2: 647.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 225.32,
    y1: 616.87,
    x2: 207.09,
    y2: 631.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.69,
    y1: 628.18,
    x2: 233.08,
    y2: 647.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.69,
    y1: 628.18,
    x2: 246.9,
    y2: 681.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 241.32,
    y1: 612.97,
    x2: 257.44,
    y2: 664.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 301.54,
    y1: 661.71,
    x2: 233.08,
    y2: 647.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.35,
    y1: 626.61,
    x2: 241.32,
    y2: 612.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270.69,
    y1: 628.18,
    x2: 241.32,
    y2: 612.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.18,
    y1: 606.27,
    x2: 241.32,
    y2: 612.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.43,
    y1: 561.68,
    x2: 293.78,
    y2: 567.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 292.67,
    y1: 605.9,
    x2: 293.78,
    y2: 567.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 279.61,
    y1: 593.43,
    x2: 259.18,
    y2: 606.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.41,
    y1: 591.52,
    x2: 259.18,
    y2: 606.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 279.61,
    y1: 593.43,
    x2: 292.67,
    y2: 605.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.43,
    y1: 561.68,
    x2: 279.61,
    y2: 593.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 293.78,
    y1: 567.94,
    x2: 253.6,
    y2: 565.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 296.76,
    y1: 548.59,
    x2: 253.6,
    y2: 565.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.43,
    y1: 561.68,
    x2: 296.76,
    y2: 548.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 253.6,
    y1: 565.52,
    x2: 254.71,
    y2: 586.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 293.78,
    y1: 567.94,
    x2: 254.71,
    y2: 586.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 279.61,
    y1: 593.43,
    x2: 254.71,
    y2: 586.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.41,
    y1: 591.52,
    x2: 248.76,
    y2: 546.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.6,
    y1: 546.55,
    x2: 253.6,
    y2: 565.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 293.78,
    y1: 567.94,
    x2: 269.6,
    y2: 546.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 279.61,
    y1: 593.43,
    x2: 293.78,
    y2: 567.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 181.3,
    y1: 556.78,
    x2: 194.13,
    y2: 585.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 193.13,
    y1: 566.73,
    x2: 174.46,
    y2: 577.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 196.85,
    y1: 575.38,
    x2: 174.46,
    y2: 577.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 194.13,
    y1: 585.06,
    x2: 175.46,
    y2: 562.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 193.13,
    y1: 566.73,
    x2: 175.46,
    y2: 562.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 236.3,
    y1: 569.62,
    x2: 224.2,
    y2: 548.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.27,
    y1: 527.01,
    x2: 296.76,
    y2: 548.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 205.23,
    y1: 565.52,
    x2: 179.18,
    y2: 541.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 175.46,
    y1: 562.05,
    x2: 181.3,
    y2: 556.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.22,
    y1: 535.01,
    x2: 181.3,
    y2: 556.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.76,
    y1: 546.55,
    x2: 218.22,
    y2: 535.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 256.39,
    y1: 525.15,
    x2: 248.76,
    y2: 546.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 236.3,
    y1: 526.64,
    x2: 248.76,
    y2: 546.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.6,
    y1: 546.55,
    x2: 283.37,
    y2: 526.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 318.23,
    y1: 541.59,
    x2: 296.76,
    y2: 548.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.6,
    y1: 546.55,
    x2: 256.39,
    y2: 525.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 236.3,
    y1: 526.64,
    x2: 224.2,
    y2: 548.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 295.59,
    y1: 513.25,
    x2: 248.76,
    y2: 546.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 296.76,
    y1: 548.59,
    x2: 256.39,
    y2: 525.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.37,
    y1: 526.27,
    x2: 293.78,
    y2: 567.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.43,
    y1: 561.68,
    x2: 283.37,
    y2: 526.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 296.76,
    y1: 548.59,
    x2: 283.37,
    y2: 526.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.27,
    y1: 527.01,
    x2: 311.24,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.24,
    y1: 533.34,
    x2: 314.62,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 318.23,
    y1: 541.59,
    x2: 311.24,
    y2: 533.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.27,
    y1: 527.01,
    x2: 311.24,
    y2: 533.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.63,
    y1: 833.62,
    x2: 327.64,
    y2: 813.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 341.04,
    y1: 837.43,
    x2: 333.63,
    y2: 833.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.76,
    y1: 546.55,
    x2: 236.3,
    y2: 569.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 253.6,
    y1: 565.52,
    x2: 248.76,
    y2: 546.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.6,
    y1: 546.55,
    x2: 236.3,
    y2: 526.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.76,
    y1: 546.55,
    x2: 283.37,
    y2: 526.27
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "276.57,426.18 251.57,403.97 207.09,350.64 204.85,410.18 174.75,413.15 169.52,410.55  153.13,405.71 146.06,409.43 146.44,416.13 136.98,449.25 140.1,464.5 144.2,454.83 174.75,493.52 175.75,460.41 203.74,490.55  229.04,489.06 249.99,494.52 278.53,488.06 293.78,455.94 308.76,455.37  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "308.76,455.37 302.52,449.25 283.37,444.04 273.69,456.69 249.13,475.66 214.53,473.8  203.37,471.57 205.11,428.78 221.87,427.29 231.25,426.18 268.85,426.18 276.57,426.18  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 136.98,
    y1: 449.25,
    x2: 134.24,
    y2: 500.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 140.1,
    y1: 464.5,
    x2: 134.24,
    y2: 500.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 136.98,
    y1: 449.25,
    x2: 144.2,
    y2: 454.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.44,
    y1: 416.13,
    x2: 144.2,
    y2: 454.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 175.75,
    y1: 460.41,
    x2: 153.13,
    y2: 405.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170.83,
    y1: 503.08,
    x2: 140.1,
    y2: 464.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 175.75,
    y1: 460.41,
    x2: 136.98,
    y2: 449.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.52,
    y1: 410.55,
    x2: 175.75,
    y2: 460.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.75,
    y1: 413.15,
    x2: 144.2,
    y2: 454.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.37,
    y1: 471.57,
    x2: 174.75,
    y2: 413.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 205.11,
    y1: 428.78,
    x2: 175.75,
    y2: 460.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.37,
    y1: 471.57,
    x2: 175.75,
    y2: 460.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 229.04,
    y1: 489.06,
    x2: 175.75,
    y2: 460.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 204.85,
    y1: 410.18,
    x2: 205.11,
    y2: 428.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 229.04,
    y1: 489.06,
    x2: 236.3,
    y2: 526.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 249.99,
    y1: 494.52,
    x2: 256.39,
    y2: 525.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.18,
    y1: 496.5,
    x2: 256.39,
    y2: 525.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 249.99,
    y1: 494.52,
    x2: 236.3,
    y2: 526.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 229.04,
    y1: 489.06,
    x2: 256.39,
    y2: 525.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 278.53,
    y1: 488.06,
    x2: 283.37,
    y2: 526.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 249.99,
    y1: 494.52,
    x2: 283.37,
    y2: 526.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.18,
    y1: 496.5,
    x2: 248.76,
    y2: 546.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 221.87,
    y1: 427.29,
    x2: 203.37,
    y2: 471.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.75,
    y1: 493.52,
    x2: 203.37,
    y2: 471.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.74,
    y1: 490.55,
    x2: 203.37,
    y2: 471.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.75,
    y1: 493.52,
    x2: 209.81,
    y2: 528.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.37,
    y1: 471.57,
    x2: 170.83,
    y2: 503.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.75,
    y1: 493.52,
    x2: 170.83,
    y2: 503.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.74,
    y1: 490.55,
    x2: 203.74,
    y2: 501.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.75,
    y1: 493.52,
    x2: 179.18,
    y2: 541.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.74,
    y1: 490.55,
    x2: 179.18,
    y2: 541.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.75,
    y1: 493.52,
    x2: 203.74,
    y2: 490.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 229.04,
    y1: 489.06,
    x2: 209.81,
    y2: 528.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.74,
    y1: 501.34,
    x2: 209.81,
    y2: 528.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.18,
    y1: 541.9,
    x2: 209.81,
    y2: 528.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.76,
    y1: 546.55,
    x2: 203.74,
    y2: 501.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.22,
    y1: 535.01,
    x2: 203.74,
    y2: 501.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.83,
    y1: 459.66,
    x2: 202.39,
    y2: 502.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 249.13,
    y1: 475.66,
    x2: 255.83,
    y2: 459.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 295.59,
    y1: 513.25,
    x2: 272.18,
    y2: 496.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.27,
    y1: 527.01,
    x2: 272.18,
    y2: 496.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 295.59,
    y1: 513.25,
    x2: 278.53,
    y2: 488.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.24,
    y1: 489.06,
    x2: 278.53,
    y2: 488.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 273.69,
    y1: 456.69,
    x2: 311.24,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 293.78,
    y1: 455.94,
    x2: 314.62,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.76,
    y1: 455.37,
    x2: 314.62,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 302.52,
    y1: 449.25,
    x2: 314.62,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 293.78,
    y1: 455.94,
    x2: 311.24,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 302.52,
    y1: 449.25,
    x2: 273.69,
    y2: 456.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 293.78,
    y1: 455.94,
    x2: 249.13,
    y2: 475.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 273.69,
    y1: 456.69,
    x2: 278.53,
    y2: 488.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.37,
    y1: 444.04,
    x2: 272.18,
    y2: 496.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.83,
    y1: 459.66,
    x2: 278.53,
    y2: 488.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.18,
    y1: 496.5,
    x2: 255.83,
    y2: 459.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 278.53,
    y1: 488.06,
    x2: 249.13,
    y2: 475.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 249.99,
    y1: 494.52,
    x2: 249.13,
    y2: 475.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 229.04,
    y1: 489.06,
    x2: 249.13,
    y2: 475.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 249.99,
    y1: 494.52,
    x2: 273.69,
    y2: 456.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.18,
    y1: 496.5,
    x2: 249.99,
    y2: 494.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.74,
    y1: 501.34,
    x2: 249.99,
    y2: 494.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 214.53,
    y1: 473.8,
    x2: 229.04,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.74,
    y1: 490.55,
    x2: 214.53,
    y2: 473.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 205.11,
    y1: 428.78,
    x2: 214.53,
    y2: 473.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.25,
    y1: 426.18,
    x2: 214.53,
    y2: 473.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 209.81,
    y1: 528.06,
    x2: 205.23,
    y2: 565.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.85,
    y1: 426.18,
    x2: 255.83,
    y2: 459.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 221.87,
    y1: 427.29,
    x2: 255.83,
    y2: 459.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.85,
    y1: 426.18,
    x2: 203.37,
    y2: 471.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.83,
    y1: 459.66,
    x2: 203.37,
    y2: 471.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 249.13,
    y1: 475.66,
    x2: 231.25,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 273.69,
    y1: 456.69,
    x2: 231.25,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.37,
    y1: 444.04,
    x2: 221.87,
    y2: 427.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 276.57,
    y1: 426.18,
    x2: 255.83,
    y2: 459.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 273.69,
    y1: 456.69,
    x2: 276.57,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 251.57,
    y1: 403.97,
    x2: 273.69,
    y2: 456.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.22,
    y1: 535.01,
    x2: 193.13,
    y2: 566.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 235.3,
    y1: 606.19,
    x2: 225.32,
    y2: 616.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 254.71,
    y1: 586.92,
    x2: 227.92,
    y2: 606.01
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "256.57,375.33 287.82,330.12 271.46,320.03 259.36,331.98 252.29,299.61 226.86,348.31  230.6,324.59 231.08,301.1 223.75,289.75 213.4,266.12 222.87,266.12 250.99,273.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "360.65,369.78 341.41,358.96 314.98,384.96 309.76,347.03 291.47,377.29 303.51,381.83  306.03,396.89 312.19,404.14 308.08,408.9 283.88,411.66 274.13,394.76 264.28,361.95  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.19,
    y1: 404.14,
    x2: 308.76,
    y2: 455.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 302.52,
    y1: 449.25,
    x2: 312.19,
    y2: 404.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.88,
    y1: 411.66,
    x2: 276.57,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.08,
    y1: 408.9,
    x2: 276.57,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.88,
    y1: 411.66,
    x2: 302.52,
    y2: 449.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.08,
    y1: 408.9,
    x2: 283.37,
    y2: 444.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 293.78,
    y1: 455.94,
    x2: 308.08,
    y2: 408.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 306.03,
    y1: 396.89,
    x2: 302.52,
    y2: 449.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.85,
    y1: 426.18,
    x2: 302.52,
    y2: 449.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.37,
    y1: 444.04,
    x2: 268.85,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.88,
    y1: 411.66,
    x2: 283.37,
    y2: 444.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.83,
    y1: 459.66,
    x2: 283.37,
    y2: 444.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 273.69,
    y1: 456.69,
    x2: 255.83,
    y2: 459.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 293.78,
    y1: 455.94,
    x2: 273.69,
    y2: 456.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.37,
    y1: 444.04,
    x2: 293.78,
    y2: 455.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 274.13,
    y1: 394.76,
    x2: 221.87,
    y2: 427.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 303.51,
    y1: 381.83,
    x2: 283.88,
    y2: 411.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 306.03,
    y1: 396.89,
    x2: 283.88,
    y2: 411.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 314.98,
    y1: 384.96,
    x2: 283.88,
    y2: 411.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.19,
    y1: 404.14,
    x2: 314.98,
    y2: 384.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 303.51,
    y1: 381.83,
    x2: 314.98,
    y2: 384.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 291.47,
    y1: 377.29,
    x2: 306.03,
    y2: 396.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 274.13,
    y1: 394.76,
    x2: 306.03,
    y2: 396.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 291.47,
    y1: 377.29,
    x2: 283.88,
    y2: 411.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.85,
    y1: 426.18,
    x2: 274.13,
    y2: 394.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 291.47,
    y1: 377.29,
    x2: 268.85,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 274.13,
    y1: 394.76,
    x2: 276.57,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 256.57,
    y1: 375.33,
    x2: 276.57,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.46,
    y1: 320.03,
    x2: 291.47,
    y2: 377.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 291.47,
    y1: 377.29,
    x2: 274.13,
    y2: 394.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 264.28,
    y1: 361.95,
    x2: 291.47,
    y2: 377.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 287.82,
    y1: 330.12,
    x2: 303.51,
    y2: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 256.57,
    y1: 375.33,
    x2: 303.51,
    y2: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.88,
    y1: 411.66,
    x2: 264.28,
    y2: 361.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.19,
    y1: 404.14,
    x2: 283.88,
    y2: 411.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.08,
    y1: 408.9,
    x2: 251.57,
    y2: 403.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 226.86,
    y1: 348.31,
    x2: 204.85,
    y2: 410.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 251.57,
    y1: 403.97,
    x2: 226.86,
    y2: 348.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 256.57,
    y1: 375.33,
    x2: 204.85,
    y2: 410.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 251.57,
    y1: 403.97,
    x2: 205.11,
    y2: 428.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 256.57,
    y1: 375.33,
    x2: 231.25,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 251.57,
    y1: 403.97,
    x2: 256.57,
    y2: 375.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 274.13,
    y1: 394.76,
    x2: 204.85,
    y2: 410.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 221.87,
    y1: 427.29,
    x2: 204.85,
    y2: 410.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.85,
    y1: 426.18,
    x2: 204.85,
    y2: 410.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.43,
    y1: 561.68,
    x2: 310.83,
    y2: 532.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.41,
    y1: 591.52,
    x2: 310.83,
    y2: 532.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 296.76,
    y1: 548.59,
    x2: 299.41,
    y2: 591.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.43,
    y1: 597.71,
    x2: 299.41,
    y2: 591.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 293.78,
    y1: 567.94,
    x2: 296.76,
    y2: 548.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 308.27,
    y1: 527.01,
    x2: 293.78,
    y2: 567.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.46,
    y1: 320.03,
    x2: 264.28,
    y2: 361.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.36,
    y1: 331.98,
    x2: 264.28,
    y2: 361.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 226.86,
    y1: 348.31,
    x2: 264.28,
    y2: 361.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 256.57,
    y1: 375.33,
    x2: 259.36,
    y2: 331.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.09,
    y1: 350.64,
    x2: 256.57,
    y2: 375.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 264.28,
    y1: 361.95,
    x2: 207.09,
    y2: 350.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.6,
    y1: 324.59,
    x2: 264.28,
    y2: 361.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 226.86,
    y1: 348.31,
    x2: 271.46,
    y2: 320.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 287.82,
    y1: 330.12,
    x2: 259.36,
    y2: 331.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 220.61,
    y1: 332.85,
    x2: 259.36,
    y2: 331.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250.99,
    y1: 273.73,
    x2: 231.08,
    y2: 301.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250.99,
    y1: 276.56,
    x2: 223.75,
    y2: 289.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.29,
    y1: 299.61,
    x2: 250.99,
    y2: 276.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.6,
    y1: 324.59,
    x2: 250.99,
    y2: 273.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.29,
    y1: 299.61,
    x2: 213.4,
    y2: 266.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.6,
    y1: 324.59,
    x2: 252.29,
    y2: 299.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.08,
    y1: 301.1,
    x2: 252.29,
    y2: 299.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.75,
    y1: 289.75,
    x2: 252.29,
    y2: 299.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.46,
    y1: 320.03,
    x2: 231.08,
    y2: 301.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.6,
    y1: 324.59,
    x2: 271.46,
    y2: 320.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.75,
    y1: 289.75,
    x2: 220.61,
    y2: 332.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 383.04,
    y1: 583.57,
    x2: 392.16,
    y2: 547.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 383.42,
    y1: 569.03,
    x2: 383.04,
    y2: 583.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 427.9,
    y1: 570.06,
    x2: 445.39,
    y2: 540.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 432.84,
    y1: 519.7,
    x2: 437.64,
    y2: 533.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 445.39,
    y1: 540.78,
    x2: 437.64,
    y2: 533.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 412.69,
    y1: 460.01,
    x2: 419.54,
    y2: 445.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 427.52,
    y1: 415.91,
    x2: 427.52,
    y2: 438.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.38,
    y1: 407.9,
    x2: 389.12,
    y2: 430.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 394.82,
    y1: 399.75,
    x2: 427.52,
    y2: 438.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 415.35,
    y1: 393.33,
    x2: 427.52,
    y2: 438.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 427.52,
    y1: 415.91,
    x2: 415.35,
    y2: 393.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 406.23,
    y1: 378.58,
    x2: 394.82,
    y2: 399.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 405.09,
    y1: 328.47,
    x2: 406.23,
    y2: 378.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 373.91,
    y1: 361.99,
    x2: 406.23,
    y2: 378.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 375.44,
    y1: 381.32,
    x2: 406.23,
    y2: 378.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 370.87,
    y1: 396.75,
    x2: 406.23,
    y2: 378.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 360.65,
    y1: 369.78,
    x2: 375.44,
    y2: 381.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 370.87,
    y1: 396.75,
    x2: 360.65,
    y2: 369.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 388.74,
    y1: 449.99,
    x2: 422.58,
    y2: 504.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 375.44,
    y1: 381.32,
    x2: 380.38,
    y2: 407.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 415.35,
    y1: 393.33,
    x2: 389.12,
    y2: 430.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 427.52,
    y1: 415.91,
    x2: 394.82,
    y2: 399.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 370.87,
    y1: 396.75,
    x2: 394.82,
    y2: 399.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 406.23,
    y1: 378.58,
    x2: 380.38,
    y2: 407.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 415.35,
    y1: 393.33,
    x2: 370.87,
    y2: 396.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 373.91,
    y1: 361.99,
    x2: 394.82,
    y2: 399.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 375.44,
    y1: 381.32,
    x2: 430.56,
    y2: 406.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 394.82,
    y1: 399.75,
    x2: 430.56,
    y2: 406.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.38,
    y1: 429.45,
    x2: 394.82,
    y2: 399.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.38,
    y1: 407.9,
    x2: 380.38,
    y2: 429.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 405.09,
    y1: 328.47,
    x2: 373.91,
    y2: 361.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.38,
    y1: 322.31,
    x2: 373.91,
    y2: 361.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 411.55,
    y1: 601.8,
    x2: 410.41,
    y2: 618.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 417.95,
    y1: 595.41,
    x2: 419.54,
    y2: 612.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 421.82,
    y1: 545.09,
    x2: 439.3,
    y2: 570.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 398.25,
    y1: 537.8,
    x2: 401.29,
    y2: 559.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 432.84,
    y1: 519.7,
    x2: 398.25,
    y2: 537.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 413.45,
    y1: 563.99,
    x2: 392.16,
    y2: 547.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 398.25,
    y1: 537.8,
    x2: 409.27,
    y2: 549.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 421.82,
    y1: 545.09,
    x2: 398.25,
    y2: 537.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 418.01,
    y1: 535.85,
    x2: 383.42,
    y2: 569.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 398.25,
    y1: 537.8,
    x2: 418.01,
    y2: 535.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 392.16,
    y1: 547.48,
    x2: 418.01,
    y2: 535.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 409.27,
    y1: 549.73,
    x2: 392.16,
    y2: 547.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 383.42,
    y1: 569.03,
    x2: 409.27,
    y2: 549.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 392.16,
    y1: 547.48,
    x2: 401.29,
    y2: 559.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 398.25,
    y1: 537.8,
    x2: 383.23,
    y2: 582.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 427.9,
    y1: 570.06,
    x2: 409.27,
    y2: 549.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 421.82,
    y1: 545.09,
    x2: 427.9,
    y2: 570.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 416.11,
    y1: 514.7,
    x2: 418.01,
    y2: 535.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 445.39,
    y1: 540.78,
    x2: 421.82,
    y2: 545.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 437.64,
    y1: 533.01,
    x2: 421.82,
    y2: 545.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 445.39,
    y1: 514.7,
    x2: 421.82,
    y2: 545.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 437.64,
    y1: 533.01,
    x2: 445.39,
    y2: 514.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 439.3,
    y1: 570.92,
    x2: 437.42,
    y2: 532.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 432.84,
    y1: 519.7,
    x2: 421.82,
    y2: 545.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 442.73,
    y1: 509.84,
    x2: 432.84,
    y2: 519.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 416.11,
    y1: 514.7,
    x2: 437.64,
    y2: 533.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 422.58,
    y1: 504.87,
    x2: 415.54,
    y2: 515.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 429.42,
    y1: 489.06,
    x2: 421.82,
    y2: 545.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 432.84,
    y1: 519.7,
    x2: 429.42,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 442.73,
    y1: 509.84,
    x2: 429.42,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 416.11,
    y1: 514.7,
    x2: 432.84,
    y2: 519.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 442.73,
    y1: 509.84,
    x2: 416.11,
    y2: 514.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 445.39,
    y1: 514.7,
    x2: 416.11,
    y2: 514.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 422.58,
    y1: 504.87,
    x2: 442.73,
    y2: 509.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 422.96,
    y1: 482.36,
    x2: 422.58,
    y2: 504.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 429.42,
    y1: 489.06,
    x2: 437.64,
    y2: 533.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 413.45,
    y1: 563.99,
    x2: 412.31,
    y2: 578.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 401.29,
    y1: 559.29,
    x2: 413.45,
    y2: 563.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 412.31,
    y1: 578.55,
    x2: 420.68,
    y2: 580.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 427.9,
    y1: 570.06,
    x2: 420.68,
    y2: 580.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 437.02,
    y1: 576.22,
    x2: 427.9,
    y2: 570.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 420.68,
    y1: 580.69,
    x2: 437.02,
    y2: 576.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 412.31,
    y1: 578.55,
    x2: 437.02,
    y2: 576.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 420.68,
    y1: 580.69,
    x2: 429.04,
    y2: 598.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 435.88,
    y1: 586.92,
    x2: 412.36,
    y2: 588.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 435.88,
    y1: 586.92,
    x2: 417.95,
    y2: 595.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 429.04,
    y1: 598.89,
    x2: 417.95,
    y2: 595.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 411.55,
    y1: 601.8,
    x2: 429.04,
    y2: 598.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 392.92,
    y1: 622.45,
    x2: 429.04,
    y2: 598.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 410.41,
    y1: 618.54,
    x2: 392.92,
    y2: 622.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 418.01,
    y1: 535.85,
    x2: 413.71,
    y2: 564.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 439.68,
    y1: 438.71,
    x2: 433.64,
    y2: 464.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 442.73,
    y1: 509.84,
    x2: 433.64,
    y2: 464.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 429.42,
    y1: 489.06,
    x2: 433.64,
    y2: 464.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 408.51,
    y1: 463.43,
    x2: 422.58,
    y2: 504.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 399.01,
    y1: 460.39,
    x2: 422.58,
    y2: 504.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 422.96,
    y1: 482.36,
    x2: 399.01,
    y2: 460.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 412.69,
    y1: 460.01,
    x2: 422.96,
    y2: 482.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 433.64,
    y1: 464.41,
    x2: 408.51,
    y2: 463.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 412.69,
    y1: 460.01,
    x2: 433.64,
    y2: 464.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 439.68,
    y1: 438.71,
    x2: 412.69,
    y2: 460.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 437.02,
    y1: 433.99,
    x2: 412.69,
    y2: 460.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 427.52,
    y1: 438.15,
    x2: 433.64,
    y2: 464.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 422.96,
    y1: 482.36,
    x2: 427.52,
    y2: 438.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 419.54,
    y1: 445.71,
    x2: 422.96,
    y2: 482.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 439.68,
    y1: 438.71,
    x2: 422.96,
    y2: 482.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 399.01,
    y1: 460.39,
    x2: 419.54,
    y2: 445.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 437.02,
    y1: 433.99,
    x2: 388.74,
    y2: 449.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 427.52,
    y1: 415.91,
    x2: 437.02,
    y2: 433.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 388.74,
    y1: 449.99,
    x2: 419.54,
    y2: 445.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 389.12,
    y1: 430.45,
    x2: 412.69,
    y2: 460.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 388.74,
    y1: 449.99,
    x2: 433.64,
    y2: 464.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 389.12,
    y1: 430.45,
    x2: 388.74,
    y2: 449.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.38,
    y1: 429.45,
    x2: 412.69,
    y2: 460.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 427.52,
    y1: 415.91,
    x2: 419.54,
    y2: 445.71
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "314.98,384.96 360.65,369.78 406.23,378.58 430.56,406.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "380.11,306.02 345.7,331.05 343.58,339.25 341.41,358.96 303.51,381.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "374.92,280.56 354.42,288.09 324.25,305.07 328.73,316.86 342.09,318.04 343.09,309.32 359.6,314.5  380.11,306.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "309.76,347.03 309.25,316.15 311.29,287.41 331.56,259.35 374.92,280.56  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 405.09,
    y1: 328.47,
    x2: 343.58,
    y2: 339.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 359.6,
    y1: 314.5,
    x2: 373.91,
    y2: 361.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 362.94,
    y1: 352.25,
    x2: 360.65,
    y2: 369.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 375.44,
    y1: 381.32,
    x2: 362.94,
    y2: 352.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 373.91,
    y1: 361.99,
    x2: 341.41,
    y2: 358.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.09,
    y1: 318.04,
    x2: 362.94,
    y2: 352.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 324.25,
    y1: 305.07,
    x2: 309.76,
    y2: 347.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.73,
    y1: 316.86,
    x2: 309.76,
    y2: 347.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.81,
    y1: 326.05,
    x2: 309.76,
    y2: 347.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 335.89,
    y1: 327.62,
    x2: 309.76,
    y2: 347.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 345.7,
    y1: 331.05,
    x2: 309.76,
    y2: 347.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 359.6,
    y1: 314.5,
    x2: 335.89,
    y2: 327.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 345.7,
    y1: 331.05,
    x2: 359.6,
    y2: 314.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 309.25,
    y1: 316.15,
    x2: 328.81,
    y2: 326.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.73,
    y1: 316.86,
    x2: 309.25,
    y2: 316.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 324.25,
    y1: 305.07,
    x2: 309.25,
    y2: 316.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.09,
    y1: 318.04,
    x2: 324.25,
    y2: 305.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.29,
    y1: 287.41,
    x2: 324.25,
    y2: 305.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.09,
    y1: 318.04,
    x2: 354.42,
    y2: 288.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 359.6,
    y1: 314.5,
    x2: 342.09,
    y2: 318.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 382.28,
    y1: 285.51,
    x2: 359.6,
    y2: 314.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.38,
    y1: 322.31,
    x2: 405.09,
    y2: 328.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 303.51,
    y1: 381.83,
    x2: 345.7,
    y2: 331.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 341.41,
    y1: 358.96,
    x2: 349.2,
    y2: 340.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.11,
    y1: 306.02,
    x2: 380.38,
    y2: 322.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 405.09,
    y1: 328.47,
    x2: 380.11,
    y2: 306.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 382.28,
    y1: 285.51,
    x2: 380.11,
    y2: 306.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 374.92,
    y1: 280.56,
    x2: 380.11,
    y2: 306.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 354.42,
    y1: 288.09,
    x2: 380.11,
    y2: 306.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 370.94,
    y1: 286.41,
    x2: 359.6,
    y2: 314.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.09,
    y1: 318.04,
    x2: 370.94,
    y2: 286.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.38,
    y1: 322.31,
    x2: 370.94,
    y2: 286.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 345.7,
    y1: 331.05,
    x2: 380.38,
    y2: 322.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 343.58,
    y1: 339.25,
    x2: 380.38,
    y2: 322.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.11,
    y1: 306.02,
    x2: 348.7,
    y2: 342.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.38,
    y1: 322.31,
    x2: 359.6,
    y2: 314.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 343.58,
    y1: 339.25,
    x2: 380.11,
    y2: 306.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 359.6,
    y1: 314.5,
    x2: 349.2,
    y2: 340.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.09,
    y1: 318.04,
    x2: 345.7,
    y2: 331.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.81,
    y1: 326.05,
    x2: 349.2,
    y2: 340.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 342.41,
    y1: 317.25,
    x2: 335.89,
    y2: 327.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.03,
    y1: 302.22,
    x2: 328.81,
    y2: 326.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 343.09,
    y1: 309.32,
    x2: 354.42,
    y2: 288.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "316.89,196.55 311.39,206.48 304.4,218.1 272.71,234.13 275.03,271.07 272.71,300.01 309.25,271.27  333.17,222.92 348.25,260.82 343.09,309.32  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.71,
    y1: 234.13,
    x2: 250.99,
    y2: 276.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 242.54,
    y1: 223.69,
    x2: 250.99,
    y2: 276.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 234.42,
    y1: 229.3,
    x2: 250.99,
    y2: 276.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 242.54,
    y1: 223.69,
    x2: 275.03,
    y2: 271.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 309.25,
    y1: 271.27,
    x2: 272.71,
    y2: 234.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 275.03,
    y1: 271.07,
    x2: 309.25,
    y2: 271.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 304.4,
    y1: 218.1,
    x2: 309.25,
    y2: 271.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 348.25,
    y1: 260.82,
    x2: 309.25,
    y2: 271.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 331.56,
    y1: 259.35,
    x2: 354.42,
    y2: 288.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.29,
    y1: 287.41,
    x2: 355.25,
    y2: 287.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.46,
    y1: 320.03,
    x2: 311.29,
    y2: 287.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.03,
    y1: 302.22,
    x2: 309.25,
    y2: 271.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 275.03,
    y1: 271.07,
    x2: 299.03,
    y2: 302.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 251.64,
    y1: 275.29,
    x2: 272.71,
    y2: 300.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.56,
    y1: 304.36,
    x2: 275.03,
    y2: 271.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 251.64,
    y1: 275.29,
    x2: 259.56,
    y2: 304.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.46,
    y1: 320.03,
    x2: 251.64,
    y2: 275.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.56,
    y1: 304.36,
    x2: 271.46,
    y2: 320.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.03,
    y1: 302.22,
    x2: 259.36,
    y2: 331.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 287.82,
    y1: 330.12,
    x2: 299.03,
    y2: 302.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 309.25,
    y1: 316.15,
    x2: 271.46,
    y2: 320.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 343.09,
    y1: 309.32,
    x2: 324.25,
    y2: 305.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.03,
    y1: 302.22,
    x2: 324.25,
    y2: 305.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.36,
    y1: 331.98,
    x2: 343.09,
    y2: 309.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 275.03,
    y1: 271.07,
    x2: 287.82,
    y2: 330.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.71,
    y1: 300.01,
    x2: 287.82,
    y2: 330.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.36,
    y1: 331.98,
    x2: 272.71,
    y2: 300.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.56,
    y1: 304.36,
    x2: 259.36,
    y2: 331.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.6,
    y1: 324.59,
    x2: 259.56,
    y2: 304.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.29,
    y1: 299.61,
    x2: 259.56,
    y2: 304.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 299.03,
    y1: 302.22,
    x2: 259.56,
    y2: 304.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.71,
    y1: 300.01,
    x2: 299.03,
    y2: 302.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.56,
    y1: 304.36,
    x2: 272.71,
    y2: 300.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 275.03,
    y1: 271.07,
    x2: 251.64,
    y2: 275.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 313.56,
    y1: 247.38,
    x2: 311.29,
    y2: 287.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 309.25,
    y1: 271.27,
    x2: 313.56,
    y2: 247.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 366.76,
    y1: 259.35,
    x2: 359.6,
    y2: 314.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 354.42,
    y1: 288.09,
    x2: 366.76,
    y2: 259.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 359.16,
    y1: 249.41,
    x2: 354.42,
    y2: 288.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 371.63,
    y1: 244.84,
    x2: 366.76,
    y2: 259.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 359.16,
    y1: 249.41,
    x2: 366.76,
    y2: 259.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 371.63,
    y1: 244.84,
    x2: 348.25,
    y2: 260.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 359.16,
    y1: 249.41,
    x2: 331.56,
    y2: 259.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 313.56,
    y1: 247.38,
    x2: 359.16,
    y2: 249.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 334.59,
    y1: 229.88,
    x2: 331.56,
    y2: 259.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 313.56,
    y1: 247.38,
    x2: 331.56,
    y2: 259.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 344.64,
    y1: 217.84,
    x2: 334.59,
    y2: 229.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 359.16,
    y1: 249.41,
    x2: 344.64,
    y2: 217.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 364.79,
    y1: 234.57,
    x2: 359.16,
    y2: 249.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 331.56,
    y1: 259.35,
    x2: 364.79,
    y2: 234.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 348.25,
    y1: 260.82,
    x2: 313.56,
    y2: 244.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 364.79,
    y1: 234.57,
    x2: 334.59,
    y2: 229.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 359.16,
    y1: 249.41,
    x2: 334.59,
    y2: 229.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 378.1,
    y1: 254.34,
    x2: 334.59,
    y2: 229.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 332.1,
    y1: 207.58,
    x2: 333.17,
    y2: 222.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.39,
    y1: 206.48,
    x2: 344.64,
    y2: 217.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.89,
    y1: 196.55,
    x2: 333.17,
    y2: 222.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.39,
    y1: 206.48,
    x2: 334.59,
    y2: 229.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 281.42,
    y1: 216.25,
    x2: 334.59,
    y2: 229.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 366.76,
    y1: 259.35,
    x2: 371.25,
    y2: 287.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 371.63,
    y1: 244.84,
    x2: 370.94,
    y2: 288.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 378.1,
    y1: 254.34,
    x2: 374.92,
    y2: 280.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 371.63,
    y1: 244.84,
    x2: 374.92,
    y2: 280.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 378.1,
    y1: 254.34,
    x2: 359.16,
    y2: 249.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 371.63,
    y1: 244.84,
    x2: 333.17,
    y2: 222.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 332.1,
    y1: 207.58,
    x2: 313.56,
    y2: 244.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.17,
    y1: 222.92,
    x2: 313.56,
    y2: 244.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 334.59,
    y1: 229.88,
    x2: 313.56,
    y2: 244.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 304.4,
    y1: 218.1,
    x2: 313.56,
    y2: 244.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 281.42,
    y1: 216.25,
    x2: 313.56,
    y2: 244.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.61,
    y1: 218.18,
    x2: 313.56,
    y2: 244.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.71,
    y1: 234.13,
    x2: 313.56,
    y2: 244.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 275.03,
    y1: 271.07,
    x2: 313.56,
    y2: 244.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "277.31,181.18 269.91,197.88 248.45,211 224.6,209.74 242.54,223.69 272.71,234.13  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.45,
    y1: 211,
    x2: 234.42,
    y2: 229.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.91,
    y1: 197.88,
    x2: 281.42,
    y2: 216.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.61,
    y1: 218.18,
    x2: 269.91,
    y2: 197.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 277.31,
    y1: 181.18,
    x2: 304.4,
    y2: 218.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.39,
    y1: 206.48,
    x2: 281.42,
    y2: 216.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.91,
    y1: 197.88,
    x2: 311.39,
    y2: 206.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 316.89,
    y1: 196.55,
    x2: 269.91,
    y2: 197.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 332.1,
    y1: 207.58,
    x2: 304.4,
    y2: 218.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.17,
    y1: 222.92,
    x2: 304.4,
    y2: 218.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 332.1,
    y1: 207.58,
    x2: 348.25,
    y2: 260.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 311.39,
    y1: 206.48,
    x2: 332.1,
    y2: 207.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 277.31,
    y1: 181.18,
    x2: 316.89,
    y2: 196.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 277.73,
    y1: 171.46,
    x2: 304.4,
    y2: 218.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.61,
    y1: 218.18,
    x2: 272.71,
    y2: 234.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 281.42,
    y1: 216.25,
    x2: 248.45,
    y2: 211
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.61,
    y1: 218.18,
    x2: 248.45,
    y2: 211
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 281.42,
    y1: 216.25,
    x2: 242.54,
    y2: 223.69
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "255.8,54.44 255.8,70.68 259.09,81.45 271.31,103.16 264.74,108.64 261.82,122.32 252.88,157.9  261.09,181.18 245.03,186.37 240.11,180.35 230.25,168.85 243.94,133.45 212.37,146.77 199.33,126.15 215.29,115.75 231.9,77.43  223.36,68.94 248.14,55.72 238.1,91.85 231.02,121.27 252.88,105.53  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "234.63,49.33 225.51,52.25 213.1,56.45 201.79,83.09 212.74,97.69 194.12,117.94  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.65,
    y1: 62.35,
    x2: 271.31,
    y2: 103.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 281.53,
    y1: 115.58,
    x2: 271.31,
    y2: 103.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 281.53,
    y1: 88.59,
    x2: 271.31,
    y2: 103.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.88,
    y1: 105.53,
    x2: 281.53,
    y2: 88.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 281.53,
    y1: 115.58,
    x2: 264.74,
    y2: 108.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 261.82,
    y1: 122.32,
    x2: 281.53,
    y2: 115.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.79,
    y1: 140.67,
    x2: 264.74,
    y2: 108.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.09,
    y1: 81.45,
    x2: 264.74,
    y2: 108.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.88,
    y1: 105.53,
    x2: 259.09,
    y2: 81.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 238.1,
    y1: 91.85,
    x2: 261.82,
    y2: 122.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.31,
    y1: 103.16,
    x2: 231.02,
    y2: 121.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.9,
    y1: 77.43,
    x2: 264.74,
    y2: 108.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 238.1,
    y1: 91.85,
    x2: 271.31,
    y2: 103.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.74,
    y1: 97.69,
    x2: 252.88,
    y2: 105.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 264.74,
    y1: 108.64,
    x2: 252.88,
    y2: 105.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 243.94,
    y1: 133.45,
    x2: 264.74,
    y2: 108.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.02,
    y1: 121.27,
    x2: 261.82,
    y2: 122.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.93,
    y1: 147.89,
    x2: 261.82,
    y2: 122.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.36,
    y1: 68.94,
    x2: 231.02,
    y2: 121.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.09,
    y1: 81.45,
    x2: 238.1,
    y2: 91.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.9,
    y1: 77.43,
    x2: 238.1,
    y2: 91.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.74,
    y1: 97.69,
    x2: 238.1,
    y2: 91.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.02,
    y1: 121.27,
    x2: 212.74,
    y2: 97.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.29,
    y1: 115.75,
    x2: 243.94,
    y2: 133.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.02,
    y1: 121.27,
    x2: 230.62,
    y2: 152.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.09,
    y1: 81.45,
    x2: 281.53,
    y2: 88.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.8,
    y1: 70.68,
    x2: 281.53,
    y2: 88.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.8,
    y1: 54.44,
    x2: 281.53,
    y2: 88.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.14,
    y1: 55.72,
    x2: 281.53,
    y2: 88.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.09,
    y1: 81.45,
    x2: 271.65,
    y2: 62.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.8,
    y1: 70.68,
    x2: 271.65,
    y2: 62.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.36,
    y1: 68.94,
    x2: 259.09,
    y2: 81.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.9,
    y1: 77.43,
    x2: 255.8,
    y2: 70.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.64,
    y1: 48.29,
    x2: 255.8,
    y2: 54.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.14,
    y1: 55.72,
    x2: 252.64,
    y2: 48.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 225.51,
    y1: 52.25,
    x2: 223.36,
    y2: 68.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 213.1,
    y1: 56.45,
    x2: 223.36,
    y2: 68.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.56,
    y1: 61.59,
    x2: 223.36,
    y2: 68.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.9,
    y1: 77.43,
    x2: 200.56,
    y2: 61.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 201.79,
    y1: 83.09,
    x2: 199.33,
    y2: 126.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 188.53,
    y1: 83.12,
    x2: 215.29,
    y2: 115.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 201.79,
    y1: 83.09,
    x2: 215.29,
    y2: 115.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.56,
    y1: 61.59,
    x2: 212.74,
    y2: 97.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.9,
    y1: 77.43,
    x2: 201.79,
    y2: 83.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.36,
    y1: 68.94,
    x2: 212.74,
    y2: 97.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 234.63,
    y1: 49.33,
    x2: 231.9,
    y2: 77.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.64,
    y1: 48.29,
    x2: 234.63,
    y2: 49.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 219.95,
    y1: 46.77,
    x2: 225.51,
    y2: 52.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 229.45,
    y1: 44.11,
    x2: 234.63,
    y2: 49.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 187.63,
    y1: 117.86,
    x2: 201.79,
    y2: 83.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 188.53,
    y1: 83.12,
    x2: 201.79,
    y2: 83.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.56,
    y1: 61.59,
    x2: 201.79,
    y2: 83.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 188.53,
    y1: 83.12,
    x2: 225.51,
    y2: 52.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 213.1,
    y1: 56.45,
    x2: 188.53,
    y2: 83.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 194.12,
    y1: 117.94,
    x2: 188.53,
    y2: 83.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.9,
    y1: 77.43,
    x2: 225.51,
    y2: 52.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.8,
    y1: 70.68,
    x2: 248.59,
    y2: 54.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.29,
    y1: 115.75,
    x2: 194.12,
    y2: 117.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 198.42,
    y1: 151.55,
    x2: 215.29,
    y2: 115.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.37,
    y1: 146.77,
    x2: 215.29,
    y2: 115.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.37,
    y1: 146.77,
    x2: 231.02,
    y2: 121.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 261.82,
    y1: 122.32,
    x2: 230.62,
    y2: 152.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.79,
    y1: 140.67,
    x2: 243.94,
    y2: 133.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 199.33,
    y1: 126.15,
    x2: 243.94,
    y2: 133.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.88,
    y1: 157.9,
    x2: 243.94,
    y2: 133.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.79,
    y1: 140.67,
    x2: 252.88,
    y2: 157.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.93,
    y1: 147.89,
    x2: 230.62,
    y2: 152.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.88,
    y1: 157.9,
    x2: 272.93,
    y2: 147.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 246.22,
    y1: 168.31,
    x2: 272.93,
    y2: 147.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 194.12,
    y1: 117.94,
    x2: 198.42,
    y2: 151.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 199.33,
    y1: 126.15,
    x2: 198.42,
    y2: 151.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.79,
    y1: 140.67,
    x2: 261.09,
    y2: 181.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.88,
    y1: 157.9,
    x2: 277.73,
    y2: 171.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 277.31,
    y1: 181.18,
    x2: 277.73,
    y2: 171.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.91,
    y1: 197.88,
    x2: 261.09,
    y2: 181.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.31,
    y1: 176.32,
    x2: 269.91,
    y2: 197.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 277.31,
    y1: 181.18,
    x2: 271.31,
    y2: 176.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 277.73,
    y1: 171.46,
    x2: 271.31,
    y2: 176.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.88,
    y1: 157.9,
    x2: 271.31,
    y2: 176.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 246.22,
    y1: 168.31,
    x2: 271.31,
    y2: 176.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.62,
    y1: 152.61,
    x2: 271.31,
    y2: 176.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.64,
    y1: 48.29,
    x2: 223.36,
    y2: 68.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.8,
    y1: 54.44,
    x2: 234.63,
    y2: 49.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.8,
    y1: 70.68,
    x2: 219.95,
    y2: 46.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 229.45,
    y1: 44.11,
    x2: 255.8,
    y2: 70.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.09,
    y1: 81.45,
    x2: 225.51,
    y2: 52.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.8,
    y1: 70.68,
    x2: 213.1,
    y2: 56.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.14,
    y1: 55.72,
    x2: 225.51,
    y2: 52.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.93,
    y1: 147.89,
    x2: 271.31,
    y2: 176.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 245.03,
    y1: 186.37,
    x2: 269.91,
    y2: 197.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.45,
    y1: 211,
    x2: 245.03,
    y2: 186.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 261.09,
    y1: 181.18,
    x2: 248.45,
    y2: 211
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.61,
    y1: 218.18,
    x2: 246.22,
    y2: 168.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 224.6,
    y1: 209.74,
    x2: 261.09,
    y2: 181.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.61,
    y1: 218.18,
    x2: 245.03,
    y2: 186.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.71,
    y1: 234.13,
    x2: 245.03,
    y2: 186.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.61,
    y1: 218.18,
    x2: 234.42,
    y2: 229.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 199.33,
    y1: 126.15,
    x2: 230.62,
    y2: 152.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "243.94,133.45 220.58,148.42 215.29,115.75  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 246.22,
    y1: 168.31,
    x2: 240.11,
    y2: 180.35
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "230.25,168.85 206.65,152.9 199.33,126.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "220.58,148.42 208.54,170.5 212.19,178.75 230.62,152.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "427.52,438.15 419.54,445.71 433.64,464.41 422.96,482.36 429.42,489.06 422.58,504.87  432.84,519.7 418.01,535.85 421.82,545.09 409.27,549.73 413.45,563.99 420.68,580.69 417.95,595.41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "383.42,569.03 392.16,547.48 398.25,537.8 416.11,514.7 408.51,463.43 399.01,460.39 388.74,449.99  380.38,429.45 370.87,396.75 375.44,381.32 373.91,361.99 362.94,352.25 349.2,340.99 380.38,322.31 406.23,378.58 415.35,393.33  394.82,399.75 389.12,430.45 427.52,438.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "224.6,209.74 221.88,191.12 223.24,177.98 207.02,189.53 218.58,205.53 199.42,200.22  203.22,161.96 198.42,151.55 187.63,117.86 188.53,83.12 200.56,61.59 219.95,46.77 229.45,44.11 252.64,48.29 271.65,62.35  281.53,88.59 281.53,115.58 272.79,140.67 272.93,147.89 277.73,171.46 316.89,196.55 332.1,207.58 344.64,217.84 364.79,234.57  371.63,244.84 378.1,254.34 382.28,285.51 405.09,328.47 430.56,406.43 437.02,433.99 439.68,438.71 442.73,509.84 445.39,514.7  445.39,540.78 439.3,570.92 437.02,576.22 435.88,586.92 429.04,598.89 419.54,612.5 410.41,618.54 397.87,625.8 392.92,622.45  411.55,601.8 412.36,588.98 412.31,578.55 401.29,559.29 383.42,569.03  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 245.03,
    y1: 186.37,
    x2: 224.6,
    y2: 209.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 240.11,
    y1: 180.35,
    x2: 218.58,
    y2: 205.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 221.88,
    y1: 191.12,
    x2: 245.03,
    y2: 186.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.88,
    y1: 157.9,
    x2: 245.03,
    y2: 186.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.62,
    y1: 152.61,
    x2: 246.22,
    y2: 168.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 240.11,
    y1: 180.35,
    x2: 221.88,
    y2: 191.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.24,
    y1: 177.98,
    x2: 245.03,
    y2: 186.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 240.11,
    y1: 180.35,
    x2: 223.24,
    y2: 177.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.62,
    y1: 152.61,
    x2: 240.11,
    y2: 180.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 246.22,
    y1: 168.31,
    x2: 223.24,
    y2: 177.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 261.09,
    y1: 181.18,
    x2: 230.25,
    y2: 168.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.31,
    y1: 176.32,
    x2: 240.11,
    y2: 180.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 261.09,
    y1: 181.18,
    x2: 277.31,
    y2: 181.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.88,
    y1: 157.9,
    x2: 230.25,
    y2: 168.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.62,
    y1: 152.61,
    x2: 252.88,
    y2: 157.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 198.42,
    y1: 151.55,
    x2: 206.65,
    y2: 152.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.62,
    y1: 152.61,
    x2: 203.22,
    y2: 161.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 220.58,
    y1: 148.42,
    x2: 221.88,
    y2: 191.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.25,
    y1: 168.85,
    x2: 208.54,
    y2: 170.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 220.44,
    y1: 147.5,
    x2: 230.25,
    y2: 168.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.62,
    y1: 152.61,
    x2: 206.65,
    y2: 152.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 198.42,
    y1: 151.55,
    x2: 212.37,
    y2: 146.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.29,
    y1: 115.75,
    x2: 206.65,
    y2: 152.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 220.58,
    y1: 148.42,
    x2: 230.62,
    y2: 152.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 206.65,
    y1: 152.9,
    x2: 221.88,
    y2: 191.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 201.17,
    y1: 215.25,
    x2: 221.88,
    y2: 191.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.45,
    y1: 211,
    x2: 221.88,
    y2: 191.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.62,
    y1: 167.91,
    x2: 224.6,
    y2: 209.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 240.11,
    y1: 180.35,
    x2: 242.54,
    y2: 223.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.22,
    y1: 161.96,
    x2: 207.02,
    y2: 189.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 208.54,
    y1: 170.5,
    x2: 203.22,
    y2: 161.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.88,
    y1: 157.9,
    x2: 206.65,
    y2: 152.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.02,
    y1: 189.53,
    x2: 199.42,
    y2: 200.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.24,
    y1: 177.98,
    x2: 199.33,
    y2: 205.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.62,
    y1: 152.61,
    x2: 223.24,
    y2: 177.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.19,
    y1: 178.75,
    x2: 224.6,
    y2: 209.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 208.54,
    y1: 170.5,
    x2: 207.02,
    y2: 189.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.62,
    y1: 167.91,
    x2: 221.88,
    y2: 191.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.19,
    y1: 178.75,
    x2: 207.02,
    y2: 189.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 201.17,
    y1: 215.25,
    x2: 207.02,
    y2: 189.53
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "199.42,200.22 152.46,236.05 140.92,247.38 130.26,267.45 130.26,275.73 125.81,299.16  125.81,304.36 124.63,324.54 123.44,339.04 126.41,343.27 110.42,368.12 107.45,378.58 101.83,392.75 80.21,430.33 74.59,456.32  61.85,485.09 42.9,525.95 37.87,551.82 41.13,561.68 33.13,580.69 34.91,601.8 46.16,616.87 63.63,622.45 63.63,605.3  59.78,580.69 73.4,547.48 74.29,523.94 78.73,513.21 103.01,492.04 121.78,469.15 129.07,452.97 132.99,438.94 135.98,407.9  166.38,375.33 171.12,369.62 199.84,340.99 181.67,307.2 183.85,273.72 183.85,267.45 187.74,235.2 154.54,282.87 158.39,306.02  161.05,329.78 174.97,329.78 169.53,352.53 143.88,368.12 142.99,386.03 169.52,410.55 144.2,454.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "142.1,278.1 145.32,307.2 146.54,318.41 148.02,327.75 146.84,338.24 132.62,374.33 124.33,381.83  115.46,392.85 100.35,407.9 92.35,419.48 90.28,451.85 95.91,472.32 85.54,495.93 102.42,475.61 110.12,478.08 107.75,459.91  107.75,444.59 123.23,418.73 119.3,406.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "75.77,473.86 66.3,501.28 49.01,524.94 62.89,541.59 55.34,547.48  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.64,
    y1: 336.54,
    x2: 146.84,
    y2: 338.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.92,
    y1: 310.61,
    x2: 146.84,
    y2: 338.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "146.84,253.37 164.44,262.7 146.84,273.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "51.79,609.4 55.64,601.16 53.71,594.43 46.16,591.52 65.11,559.29 60.67,558.08 46.16,553.87  50.01,563.26 48.82,580.69 39.65,580.69  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 51.79,
    y1: 609.4,
    x2: 63.63,
    y2: 622.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 63.63,
    y1: 605.3,
    x2: 51.79,
    y2: 609.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 48.82,
    y1: 580.69,
    x2: 63.63,
    y2: 605.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 59.78,
    y1: 580.69,
    x2: 48.82,
    y2: 580.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 41.13,
    y1: 561.68,
    x2: 59.78,
    y2: 580.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 55.34,
    y1: 547.48,
    x2: 59.78,
    y2: 580.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 49.01,
    y1: 524.94,
    x2: 37.87,
    y2: 551.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 74.29,
    y1: 523.94,
    x2: 49.01,
    y2: 524.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 66.3,
    y1: 501.28,
    x2: 74.29,
    y2: 523.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 61.85,
    y1: 485.09,
    x2: 66.3,
    y2: 501.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 49.01,
    y1: 524.94,
    x2: 46.16,
    y2: 553.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 62.89,
    y1: 541.59,
    x2: 60.67,
    y2: 558.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65.11,
    y1: 559.29,
    x2: 73.4,
    y2: 547.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 74.29,
    y1: 523.94,
    x2: 67.48,
    y2: 537.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 42.9,
    y1: 525.95,
    x2: 62.89,
    y2: 541.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 55.34,
    y1: 547.48,
    x2: 37.87,
    y2: 551.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 50.01,
    y1: 563.26,
    x2: 59.78,
    y2: 580.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 42.9,
    y1: 525.95,
    x2: 66.3,
    y2: 501.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 78.73,
    y1: 513.21,
    x2: 85.54,
    y2: 495.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 66.3,
    y1: 501.28,
    x2: 85.54,
    y2: 495.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 61.85,
    y1: 485.09,
    x2: 85.54,
    y2: 495.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 75.77,
    y1: 473.86,
    x2: 85.54,
    y2: 495.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 61.85,
    y1: 485.09,
    x2: 103.01,
    y2: 492.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 85.54,
    y1: 495.93,
    x2: 103.01,
    y2: 492.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 75.77,
    y1: 473.86,
    x2: 103.01,
    y2: 492.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 61.85,
    y1: 485.09,
    x2: 75.77,
    y2: 473.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 74.59,
    y1: 456.32,
    x2: 66.3,
    y2: 501.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 62.89,
    y1: 541.59,
    x2: 67.48,
    y2: 537.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 80.21,
    y1: 430.33,
    x2: 90.28,
    y2: 451.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 107.75,
    y1: 444.59,
    x2: 80.21,
    y2: 430.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 92.35,
    y1: 419.48,
    x2: 107.75,
    y2: 444.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 74.59,
    y1: 456.32,
    x2: 90.28,
    y2: 451.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 107.75,
    y1: 459.91,
    x2: 74.59,
    y2: 456.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 95.91,
    y1: 472.32,
    x2: 74.59,
    y2: 456.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 107.75,
    y1: 444.59,
    x2: 90.28,
    y2: 451.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 129.07,
    y1: 452.97,
    x2: 107.75,
    y2: 444.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 121.78,
    y1: 469.15,
    x2: 107.75,
    y2: 459.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 123.23,
    y1: 418.73,
    x2: 107.75,
    y2: 459.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.99,
    y1: 438.94,
    x2: 123.23,
    y2: 418.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 100.35,
    y1: 407.9,
    x2: 132.99,
    y2: 438.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 107.75,
    y1: 459.91,
    x2: 132.99,
    y2: 438.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.06,
    y1: 409.43,
    x2: 132.99,
    y2: 438.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.75,
    y1: 413.15,
    x2: 146.44,
    y2: 416.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 75.77,
    y1: 473.86,
    x2: 129.07,
    y2: 452.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 107.75,
    y1: 444.59,
    x2: 95.91,
    y2: 472.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 107.75,
    y1: 459.91,
    x2: 103.01,
    y2: 492.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 90.28,
    y1: 451.85,
    x2: 110.12,
    y2: 478.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 90.28,
    y1: 451.85,
    x2: 129.07,
    y2: 452.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 107.75,
    y1: 459.91,
    x2: 90.28,
    y2: 451.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 75.77,
    y1: 473.86,
    x2: 95.91,
    y2: 472.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 103.01,
    y1: 492.04,
    x2: 95.91,
    y2: 472.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 129.07,
    y1: 452.97,
    x2: 95.91,
    y2: 472.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 102.42,
    y1: 475.61,
    x2: 95.91,
    y2: 472.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 121.78,
    y1: 469.15,
    x2: 110.12,
    y2: 478.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 119.3,
    y1: 406.43,
    x2: 92.35,
    y2: 419.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 101.83,
    y1: 392.75,
    x2: 92.35,
    y2: 419.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 100.35,
    y1: 407.9,
    x2: 119.3,
    y2: 406.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 101.83,
    y1: 392.75,
    x2: 100.35,
    y2: 407.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 123.23,
    y1: 418.73,
    x2: 100.35,
    y2: 407.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 101.83,
    y1: 392.75,
    x2: 123.23,
    y2: 418.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 135.98,
    y1: 407.9,
    x2: 123.23,
    y2: 418.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.06,
    y1: 409.43,
    x2: 123.23,
    y2: 418.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.63,
    y1: 373.44,
    x2: 132.99,
    y2: 438.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.53,
    y1: 352.53,
    x2: 204.85,
    y2: 410.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 171.12,
    y1: 369.62,
    x2: 204.85,
    y2: 410.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.09,
    y1: 350.64,
    x2: 171.12,
    y2: 369.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 226.86,
    y1: 348.31,
    x2: 174.75,
    y2: 413.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 171.12,
    y1: 369.62,
    x2: 174.75,
    y2: 413.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 143.88,
    y1: 368.12,
    x2: 174.75,
    y2: 413.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.06,
    y1: 409.43,
    x2: 171.12,
    y2: 369.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.79,
    y1: 373.8,
    x2: 153.74,
    y2: 407.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 171.12,
    y1: 369.62,
    x2: 152.79,
    y2: 373.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.41,
    y1: 340.99,
    x2: 171.12,
    y2: 369.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.53,
    y1: 352.53,
    x2: 171.12,
    y2: 369.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.09,
    y1: 350.64,
    x2: 169.53,
    y2: 352.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110.42,
    y1: 368.12,
    x2: 124.33,
    y2: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.62,
    y1: 374.33,
    x2: 106.91,
    y2: 379.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 135.98,
    y1: 407.9,
    x2: 119.3,
    y2: 406.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 115.46,
    y1: 392.85,
    x2: 135.98,
    y2: 407.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 101.83,
    y1: 392.75,
    x2: 135.98,
    y2: 407.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 119.3,
    y1: 406.43,
    x2: 101.83,
    y2: 392.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 124.33,
    y1: 381.83,
    x2: 119.3,
    y2: 406.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 123.23,
    y1: 418.73,
    x2: 124.33,
    y2: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 135.98,
    y1: 407.9,
    x2: 124.33,
    y2: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 101.83,
    y1: 392.75,
    x2: 124.33,
    y2: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 106.91,
    y1: 379.95,
    x2: 115.46,
    y2: 392.85
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "159.48,350.64 118.71,365.45 115.46,392.85  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110.42,
    y1: 368.12,
    x2: 115.46,
    y2: 392.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 205.11,
    y1: 428.78,
    x2: 174.75,
    y2: 413.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 221.87,
    y1: 427.29,
    x2: 174.75,
    y2: 413.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 204.85,
    y1: 410.18,
    x2: 166.38,
    y2: 375.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 159.48,
    y1: 350.64,
    x2: 166.38,
    y2: 375.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 142.99,
    y1: 386.03,
    x2: 146.06,
    y2: 409.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 124.33,
    y1: 381.83,
    x2: 174.75,
    y2: 413.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 153.13,
    y1: 405.71,
    x2: 124.33,
    y2: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 126.41,
    y1: 343.27,
    x2: 132.62,
    y2: 374.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 124.33,
    y1: 381.83,
    x2: 123.44,
    y2: 339.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 118.71,
    y1: 365.45,
    x2: 123.44,
    y2: 339.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.06,
    y1: 409.43,
    x2: 124.33,
    y2: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.52,
    y1: 410.55,
    x2: 152.79,
    y2: 373.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.84,
    y1: 338.24,
    x2: 143.88,
    y2: 368.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 124.33,
    y1: 381.83,
    x2: 152.79,
    y2: 373.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110.42,
    y1: 368.12,
    x2: 132.62,
    y2: 374.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.79,
    y1: 373.8,
    x2: 132.62,
    y2: 374.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 159.48,
    y1: 350.64,
    x2: 152.79,
    y2: 373.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 148.02,
    y1: 327.75,
    x2: 152.79,
    y2: 373.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 161.05,
    y1: 329.78,
    x2: 143.88,
    y2: 368.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.62,
    y1: 374.33,
    x2: 159.48,
    y2: 350.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 199.84,
    y1: 340.99,
    x2: 179.41,
    y2: 340.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 123.44,
    y1: 339.04,
    x2: 159.48,
    y2: 350.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.64,
    y1: 336.54,
    x2: 159.48,
    y2: 350.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "130.26,275.73 135.98,300.36 154.54,282.87  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 161.05,
    y1: 329.78,
    x2: 183.85,
    y2: 267.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 213.4,
    y1: 266.12,
    x2: 158.39,
    y2: 306.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 213.4,
    y1: 266.12,
    x2: 174.97,
    y2: 329.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.08,
    y1: 301.1,
    x2: 174.97,
    y2: 329.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.6,
    y1: 324.59,
    x2: 174.97,
    y2: 329.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.09,
    y1: 350.64,
    x2: 230.6,
    y2: 324.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 231.08,
    y1: 301.1,
    x2: 207.09,
    y2: 350.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.75,
    y1: 289.75,
    x2: 199.84,
    y2: 340.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 220.61,
    y1: 332.85,
    x2: 181.67,
    y2: 307.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.75,
    y1: 289.75,
    x2: 181.67,
    y2: 307.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 220.61,
    y1: 332.85,
    x2: 169.64,
    y2: 336.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.09,
    y1: 350.64,
    x2: 174.97,
    y2: 329.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 181.67,
    y1: 307.2,
    x2: 146.84,
    y2: 338.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.97,
    y1: 329.78,
    x2: 158.39,
    y2: 306.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 145.32,
    y1: 307.2,
    x2: 174.97,
    y2: 329.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 161.05,
    y1: 329.78,
    x2: 145.32,
    y2: 307.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 158.39,
    y1: 306.02,
    x2: 148.02,
    y2: 327.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 183.85,
    y1: 267.45,
    x2: 158.39,
    y2: 306.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "181.67,307.2 150.41,303.06 183.85,267.45  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.54,
    y1: 318.41,
    x2: 123.44,
    y2: 339.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 124.63,
    y1: 324.54,
    x2: 146.84,
    y2: 338.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 126.41,
    y1: 343.27,
    x2: 146.84,
    y2: 338.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 148.02,
    y1: 327.75,
    x2: 123.44,
    y2: 339.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 124.63,
    y1: 324.54,
    x2: 146.54,
    y2: 318.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 171.12,
    y1: 369.62,
    x2: 159.48,
    y2: 350.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.54,
    y1: 318.41,
    x2: 159.48,
    y2: 350.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.97,
    y1: 329.78,
    x2: 183.85,
    y2: 267.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 164.44,
    y1: 262.7,
    x2: 181.67,
    y2: 307.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 159.48,
    y1: 350.64,
    x2: 220.61,
    y2: 332.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 226.86,
    y1: 348.31,
    x2: 207.09,
    y2: 350.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "222.87,266.12 214.05,232.33 218.58,205.53  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "213.4,266.12 188.92,237 166.68,280.77 181.67,307.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 214.05,
    y1: 232.33,
    x2: 250.99,
    y2: 273.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 234.42,
    y1: 229.3,
    x2: 213.4,
    y2: 266.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.46,
    y1: 236.05,
    x2: 164.44,
    y2: 262.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 140.92,
    y1: 247.38,
    x2: 146.84,
    y2: 253.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.46,
    y1: 236.05,
    x2: 146.84,
    y2: 253.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.84,
    y1: 273.48,
    x2: 152.46,
    y2: 236.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 166.68,
    y1: 280.77,
    x2: 146.84,
    y2: 253.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 142.1,
    y1: 278.1,
    x2: 140.92,
    y2: 247.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130.26,
    y1: 267.45,
    x2: 146.84,
    y2: 253.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 164.44,
    y1: 262.7,
    x2: 130.26,
    y2: 267.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 187.63,
    y1: 237.25,
    x2: 146.84,
    y2: 253.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.46,
    y1: 236.05,
    x2: 187.74,
    y2: 235.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 140.92,
    y1: 247.38,
    x2: 201.17,
    y2: 215.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 214.05,
    y1: 232.33,
    x2: 164.44,
    y2: 262.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 222.87,
    y1: 266.12,
    x2: 187.74,
    y2: 235.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 142.1,
    y1: 278.1,
    x2: 125.81,
    y2: 299.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 135.98,
    y1: 300.36,
    x2: 142.1,
    y2: 278.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 154.54,
    y1: 282.87,
    x2: 142.1,
    y2: 278.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130.26,
    y1: 275.73,
    x2: 142.1,
    y2: 278.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 242.54,
    y1: 223.69,
    x2: 222.87,
    y2: 266.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.75,
    y1: 289.75,
    x2: 222.87,
    y2: 266.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250.99,
    y1: 273.73,
    x2: 183.85,
    y2: 267.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 222.87,
    y1: 266.12,
    x2: 181.67,
    y2: 307.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.75,
    y1: 289.75,
    x2: 166.68,
    y2: 280.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 183.85,
    y1: 273.72,
    x2: 223.75,
    y2: 289.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 222.87,
    y1: 266.12,
    x2: 183.85,
    y2: 273.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 183.85,
    y1: 267.45,
    x2: 213.4,
    y2: 266.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.6,
    y1: 324.59,
    x2: 213.4,
    y2: 266.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.58,
    y1: 205.53,
    x2: 188.92,
    y2: 237
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 199.33,
    y1: 205.53,
    x2: 187.74,
    y2: 235.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 201.17,
    y1: 215.25,
    x2: 187.74,
    y2: 235.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 214.05,
    y1: 232.33,
    x2: 199.33,
    y2: 205.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 242.54,
    y1: 223.69,
    x2: 199.33,
    y2: 205.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 224.6,
    y1: 209.74,
    x2: 199.33,
    y2: 205.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 124.63,
    y1: 324.54,
    x2: 132.92,
    y2: 310.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 125.72,
    y1: 305.96,
    x2: 135.98,
    y2: 300.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 125.81,
    y1: 299.16,
    x2: 135.98,
    y2: 300.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 148.02,
    y1: 327.75,
    x2: 135.98,
    y2: 300.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 124.63,
    y1: 324.54,
    x2: 145.32,
    y2: 307.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 154.54,
    y1: 282.87,
    x2: 150.41,
    y2: 303.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.84,
    y1: 273.48,
    x2: 150.41,
    y2: 303.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 183.85,
    y1: 273.72,
    x2: 164.44,
    y2: 262.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.84,
    y1: 273.48,
    x2: 166.68,
    y2: 280.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 125.81,
    y1: 299.16,
    x2: 166.68,
    y2: 280.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 183.85,
    y1: 273.72,
    x2: 146.84,
    y2: 273.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130.26,
    y1: 267.45,
    x2: 146.84,
    y2: 273.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.84,
    y1: 253.37,
    x2: 127.02,
    y2: 298.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130.26,
    y1: 267.45,
    x2: 146.54,
    y2: 318.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.92,
    y1: 310.61,
    x2: 126.41,
    y2: 343.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 148.02,
    y1: 327.75,
    x2: 132.92,
    y2: 310.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 135.98,
    y1: 300.36,
    x2: 132.92,
    y2: 310.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.54,
    y1: 318.41,
    x2: 132.92,
    y2: 310.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 148.02,
    y1: 327.75,
    x2: 161.05,
    y2: 329.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 169.53,
    y1: 352.53,
    x2: 161.05,
    y2: 329.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.09,
    y1: 350.64,
    x2: 179.41,
    y2: 340.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 181.67,
    y1: 307.2,
    x2: 179.41,
    y2: 340.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 161.05,
    y1: 329.78,
    x2: 169.64,
    y2: 336.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.97,
    y1: 329.78,
    x2: 169.64,
    y2: 336.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 164.44,
    y1: 262.7,
    x2: 213.4,
    y2: 266.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 214.53,
    y1: 473.8,
    x2: 272.18,
    y2: 496.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 249.99,
    y1: 494.52,
    x2: 214.53,
    y2: 473.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.75,
    y1: 493.52,
    x2: 214.53,
    y2: 473.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 278.53,
    y1: 488.06,
    x2: 229.04,
    y2: 489.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.18,
    y1: 496.5,
    x2: 203.74,
    y2: 501.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 224.2,
    y1: 548.97,
    x2: 179.18,
    y2: 541.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 33.13,
    y1: 580.69,
    x2: 51.79,
    y2: 609.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 34.91,
    y1: 601.8,
    x2: 51.79,
    y2: 609.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 39.65,
    y1: 580.69,
    x2: 46.16,
    y2: 616.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.16,
    y1: 591.52,
    x2: 34.91,
    y2: 601.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 39.65,
    y1: 580.69,
    x2: 34.91,
    y2: 601.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.16,
    y1: 616.87,
    x2: 33.13,
    y2: 580.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 60.67,
    y1: 558.08,
    x2: 48.82,
    y2: 580.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.46,
    y1: 577.5,
    x2: 207.09,
    y2: 631.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 194.13,
    y1: 585.06,
    x2: 203.37,
    y2: 604.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.09,
    y1: 631.94,
    x2: 203.37,
    y2: 604.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 214.2,
    y1: 614.34,
    x2: 207.09,
    y2: 631.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 225.32,
    y1: 616.87,
    x2: 214.2,
    y2: 614.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.53,
    y1: 606.52,
    x2: 214.2,
    y2: 614.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 244.48,
    y1: 575.38,
    x2: 241.32,
    y2: 612.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 233.49,
    y1: 586.92,
    x2: 259.18,
    y2: 606.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 236.3,
    y1: 569.62,
    x2: 233.49,
    y2: 586.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 244.48,
    y1: 575.38,
    x2: 227.92,
    y2: 606.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.22,
    y1: 575.37,
    x2: 235.3,
    y2: 606.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 194.13,
    y1: 585.06,
    x2: 215.53,
    y2: 606.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.62,
    y1: 585.51,
    x2: 244.48,
    y2: 575.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 193.13,
    y1: 566.73,
    x2: 248.76,
    y2: 546.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.22,
    y1: 575.37,
    x2: 248.76,
    y2: 546.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 194.13,
    y1: 585.06,
    x2: 248.76,
    y2: 546.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.22,
    y1: 535.01,
    x2: 225.32,
    y2: 616.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.37,
    y1: 604.04,
    x2: 218.22,
    y2: 535.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 205.23,
    y1: 565.52,
    x2: 203.37,
    y2: 604.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 236.3,
    y1: 526.64,
    x2: 236.3,
    y2: 569.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 233.49,
    y1: 586.92,
    x2: 227.92,
    y2: 606.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.62,
    y1: 585.51,
    x2: 225.32,
    y2: 616.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 254.71,
    y1: 586.92,
    x2: 218.22,
    y2: 575.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 233.49,
    y1: 586.92,
    x2: 218.22,
    y2: 575.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 279.61,
    y1: 593.43,
    x2: 233.49,
    y2: 586.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 244.48,
    y1: 575.38,
    x2: 259.18,
    y2: 606.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 269.6,
    y1: 546.55,
    x2: 236.3,
    y2: 569.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.76,
    y1: 546.55,
    x2: 244.48,
    y2: 575.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 256.39,
    y1: 525.15,
    x2: 253.6,
    y2: 565.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 194.13,
    y1: 585.06,
    x2: 174.46,
    y2: 577.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 181.3,
    y1: 556.78,
    x2: 174.46,
    y2: 577.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 233.49,
    y1: 586.92,
    x2: 181.3,
    y2: 556.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.22,
    y1: 535.01,
    x2: 196.51,
    y2: 576.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.62,
    y1: 585.51,
    x2: 194.13,
    y2: 585.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 235.3,
    y1: 606.19,
    x2: 212.62,
    y2: 585.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.22,
    y1: 535.01,
    x2: 218.22,
    y2: 575.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 205.23,
    y1: 565.52,
    x2: 236.3,
    y2: 526.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.22,
    y1: 575.37,
    x2: 225.32,
    y2: 616.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.53,
    y1: 606.52,
    x2: 218.22,
    y2: 575.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 254.71,
    y1: 586.92,
    x2: 244.48,
    y2: 575.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.62,
    y1: 585.51,
    x2: 218.22,
    y2: 535.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 193.13,
    y1: 566.73,
    x2: 212.62,
    y2: 585.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 168.2,
    y1: 536.31,
    x2: 175.46,
    y2: 562.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 234.42,
    y1: 229.3,
    x2: 214.05,
    y2: 232.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 187.74,
    y1: 235.2,
    x2: 214.05,
    y2: 232.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 224.6,
    y1: 209.74,
    x2: 201.17,
    y2: 215.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "91.37,1118.64 94.34,1122.36 104.02,1127.2 110.16,1130.92  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.39,
    y1: 1132.41,
    x2: 299.74,
    y2: 1110.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 333.97,
    y1: 1109.94,
    x2: 319.46,
    y2: 1110.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 305.88,
    y1: 1105.43,
    x2: 319.46,
    y2: 1110.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312.78,
    y1: 1124.6,
    x2: 287.83,
    y2: 1107.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 148.23,
    y1: 1049.38,
    x2: 150.99,
    y2: 1055.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 173.97,
    y1: 759.94,
    x2: 169.13,
    y2: 762.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 227.92,
    y1: 606.01,
    x2: 214.2,
    y2: 614.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 259.18,
    y1: 606.27,
    x2: 235.3,
    y2: 606.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 214.2,
    y1: 614.34,
    x2: 241.32,
    y2: 612.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 203.37,
    y1: 604.04,
    x2: 214.2,
    y2: 614.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.53,
    y1: 606.52,
    x2: 225.32,
    y2: 616.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 418.01,
    y1: 535.85,
    x2: 409.27,
    y2: 549.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 412.36,
    y1: 588.98,
    x2: 420.68,
    y2: 580.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 417.95,
    y1: 595.41,
    x2: 410.98,
    y2: 602.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 419.54,
    y1: 612.5,
    x2: 394.91,
    y2: 622.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 397.87,
    y1: 625.8,
    x2: 411.55,
    y2: 601.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.37,
    y1: 444.04,
    x2: 274.13,
    y2: 394.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 283.88,
    y1: 411.66,
    x2: 268.85,
    y2: 426.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 303.51,
    y1: 381.83,
    x2: 274.13,
    y2: 394.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 251.57,
    y1: 403.97,
    x2: 274.13,
    y2: 394.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 370.87,
    y1: 396.75,
    x2: 389.12,
    y2: 430.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 399.01,
    y1: 460.39,
    x2: 380.38,
    y2: 429.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 380.38,
    y1: 407.9,
    x2: 394.82,
    y2: 399.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 388.74,
    y1: 449.99,
    x2: 380.38,
    y2: 407.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 399.01,
    y1: 460.39,
    x2: 389.12,
    y2: 430.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 422.96,
    y1: 482.36,
    x2: 408.51,
    y2: 463.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 174.75,
    y1: 413.15,
    x2: 140.1,
    y2: 464.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 149.04,
    y1: 533.71,
    x2: 179.18,
    y2: 541.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.02,
    y1: 516.22,
    x2: 149.04,
    y2: 533.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 327.27,
    y1: 1145.8,
    x2: 341.04,
    y2: 1127.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 302.71,
    y1: 961.99,
    x2: 312.07,
    y2: 1008.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 354.44,
    y1: 868.97,
    x2: 325.23,
    y2: 915.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 344.76,
    y1: 856.13,
    x2: 344.39,
    y2: 893.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 268.48,
    y1: 817.62,
    x2: 299.09,
    y2: 793.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 341.04,
    y1: 837.43,
    x2: 299.09,
    y2: 793.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 298.82,
    y1: 774.82,
    x2: 267.5,
    y2: 800.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 194.13,
    y1: 585.06,
    x2: 218.67,
    y2: 574.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 181.3,
    y1: 556.78,
    x2: 193.13,
    y2: 566.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.67,
    y1: 574.95,
    x2: 193.13,
    y2: 566.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 409.27,
    y1: 549.73,
    x2: 412.31,
    y2: 578.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.73,
    y1: 316.86,
    x2: 335.89,
    y2: 327.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.81,
    y1: 326.05,
    x2: 335.89,
    y2: 327.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 328.73,
    y1: 316.86,
    x2: 328.81,
    y2: 326.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 78.73,
    y1: 513.21,
    x2: 73.4,
    y2: 547.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 107.75,
    y1: 444.59,
    x2: 121.78,
    y2: 469.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 115.46,
    y1: 392.85,
    x2: 119.3,
    y2: 406.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 118.71,
    y1: 365.45,
    x2: 124.33,
    y2: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.84,
    y1: 338.24,
    x2: 166.38,
    y2: 375.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 154.54,
    y1: 282.87,
    x2: 183.85,
    y2: 267.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 164.44,
    y1: 262.7,
    x2: 166.68,
    y2: 280.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 146.84,
    y1: 273.48,
    x2: 142.1,
    y2: 278.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 199.42,
    y1: 200.22,
    x2: 199.33,
    y2: 205.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.58,
    y1: 205.53,
    x2: 224.6,
    y2: 209.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 187.63,
    y1: 117.86,
    x2: 194.12,
    y2: 117.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 199.33,
    y1: 126.15,
    x2: 194.12,
    y2: 117.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.37,
    y1: 146.77,
    x2: 220.58,
    y2: 148.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 207.02,
    y1: 189.53,
    x2: 222.32,
    y2: 190.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 224.6,
    y1: 209.74,
    x2: 207.02,
    y2: 189.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 223.24,
    y1: 177.98,
    x2: 208.54,
    y2: 170.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.25,
    y1: 168.85,
    x2: 212.37,
    y2: 146.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 246.22,
    y1: 168.31,
    x2: 212.37,
    y2: 146.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 206.65,
    y1: 152.9,
    x2: 208.54,
    y2: 170.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 271.31,
    y1: 176.32,
    x2: 261.09,
    y2: 181.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 219.95,
    y1: 46.77,
    x2: 213.1,
    y2: 56.45
  })))), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 156.0615 933.6306)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 192.3814 945.8165)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 143.7122 955.7888)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 152.9263 968.9175)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 171.3268 983.7834)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 184.7535 984.5142)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 189.3837 988.3179)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 184.7535 991.5839)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 152.9263 991.77)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 190.614 1016.5141)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 180.7535 1022.0828)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 163.6003 1006.5048)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 155.9164 1014.6536)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 150.7552 1018.0942)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 159.428 1034.6304)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 184.6389 1031.4551)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 190.3837 1046.5581)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 184.3268 1058.3264)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 175.6678 1054.2793)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 151.1559 1056.0564)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 148.206 1049.8341)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 144.9053 1044.5192)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 130.335 1072.3279)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 157.6722 1090.1884)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 198.042 1090.1884)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 192.1954 1090.5604)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 191.8698 1105.3527)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 175.3182 1097.0652)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 166.4952 1097.2114)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 152.6736 1107.072)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 136.112 1121.2609)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 122.8001 1087.9558)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 122.4227 1108.339)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 103.8234 1101.4441)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 115.2188 1114.4017)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 110.3351 1131.1185)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 105.5258 1114.4017)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 104.2198 1127.1185)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 94.9252 1122.2609)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 90.9252 1118.4017)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 195.1804 920.6667)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 207.681 913.3515)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 193.3116 888.5143)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 201.9016 887.5143)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 210.9947 881.8167)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 208.681 875.119)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 141.9339 890.9808)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 132.1718 879.3484)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 209.9947 852.7393)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 187.1721 862.4825)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 197.6651 859.3848)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 200.2934 843.4705)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 169.049 854.6734)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 157.9902 870.6429)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 150.3824 866.6429)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 146.0171 856.0892)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 133.0327 848.3284)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 180.8358 834.0275)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 161.1257 836.7404)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 138.6244 838.2921)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 179.3954 820.1293)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 169.5927 823.9564)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 147.5334 825.8633)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 195.4884 814.4204)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 200.9395 808.1424)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 199.2934 795.7246)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 141.3117 809.7172)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 189.0683 788.1883)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 195.7302 777.2574)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 135.9105 794.0029)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 203.5442 740.7937)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 174.2565 759.9243)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 169.3117 762.6043)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 147.0792 774.6541)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 161.1257 786.561)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 127.9037 769.6309)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 136.5091 764.3736)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 160.9951 746.2693)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 129.9839 755.3053)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 174.6373 729.6309)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 210.986 705.817)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 177.4977 703.2124)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 150.7071 716.7356)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 179.3582 657.4451)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 117.5443 688.5148)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 113.9114 675.7938)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 207.2048 631.6902)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 233.4727 647.133)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 150.7909 641.0167)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 145.8464 646.642)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 132.1955 662.4451)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 126.335 657.1484)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 138.2885 625.2553)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 123.8398 627.8703)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 117.5443 624.5267)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 114.9461 591.6686)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 144.8592 577.213)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 122.2095 577.4296)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 138.792 546.7476)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 258.6138 1153.4441)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 280.9394 1151.2115)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 258.6138 1147.8627)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 267.9161 1136.1417)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 285.4045 1139.3046)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 312.0269 1150.6533)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 270.6862 1124.8462)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 300.1021 1110.6112)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 298.9161 1125.4209)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 313.0625 1124.5671)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 288.0091 1108.0023)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 334.1579 1110.3046)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 306.0556 1105.6301)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 327.5222 1146.0536)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 319.8459 1110.3046)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 325.5667 1097.6069)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 327.5222 1121.2911)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 341.9776 1118.8309)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 340.9776 1127.7444)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 331.5763 1114.8309)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 334.1579 1133.4055)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 328.5222 1132.5721)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 333.1579 1076.7689)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 339.7299 1072.3279)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 324.8463 1062.6536)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 322.0899 1065.5952)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 305.7765 1081.705)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 301.7765 1075.1831)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 294.7068 1089.072)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 294.7068 1068.421)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 306.0556 1052.049)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 340.2183 1036.9791)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 323.8463 1038.4767)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 303.2649 1036.6071)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 326.0788 1014.2955)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 312.4626 1008.8473)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 303.2649 1017.0679)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 341.1352 985.0793)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 310.3347 984.1421)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 294.9995 973.8919)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 335.9104 950.5074)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 341.7183 942.8694)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 302.9014 962.1707)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 291.1948 956.2837)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 338.8789 962.287)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 323.137 933.5375)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 325.5161 915.0724)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 285.4045 906.1887)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 344.2841 893.202)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 353.9916 885.118)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 330.4276 899.6074)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 309.1498 883.3051)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 296.8705 877.1341)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 354.1278 870.3317)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 346.7551 865.4532)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 344.7532 856.0815)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 341.2183 837.6307)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 333.8557 833.963)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 314.274 837.963)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 276.8571 849.9406)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 279.1929 857.4712)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 327.6666 814.0926)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 280.1929 813.1243)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 320.9393 794.0029)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 299.1841 794.0029)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 255.6371 817.8168)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 268.6603 817.8168)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 267.652 799.7504)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 318.173 767.2123)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 285.0805 783.0394)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 299.1841 774.9974)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 274.5664 761.3286)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 252.0724 780.9822)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 299.5863 728.5038)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 270.8929 739.5612)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 246.7069 741.1658)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 239.6371 747.8635)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 318.6486 707.3054)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 279.7863 708.3054)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 312.5672 693.6915)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 231.1273 713.6415)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 242.2418 693.9101)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 225.7714 695.6617)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 301.7184 661.9102)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 318.6486 644.362)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 247.079 682.0031)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 257.9943 664.6232)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 270.8694 628.3832)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 320.8561 627.0444)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 312.5121 626.4536)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 316.5121 597.8764)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 292.8463 606.0963)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 299.451 591.7175)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 279.4722 593.3279)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 293.8463 568.04)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 316.0783 562.027)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 259.8654 606.2823)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 254.8929 587.1196)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 241.4783 612.9279)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 233.671 587.1196)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 244.7049 575.5706)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 253.8929 565.5864)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 236.3391 569.5864)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 235.3391 606.3875)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 270.0557 546.5671)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 225.2757 617.0224)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 227.729 606.4752)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 215.7493 606.4752)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 214.3787 614.5381)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 203.2048 604.4725)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 212.8338 585.4842)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 194.3116 585.2592)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 174.6047 577.1519)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 224.6603 549.0663)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 218.8445 575.1533)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 197.1352 575.7829)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 205.3793 565.5864)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 193.1352 566.9976)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 175.7044 562.1927)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 248.7049 546.7476)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 181.4315 557.1104)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 179.5055 541.7883)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 168.5644 536.6081)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 283.544 526.4686)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 256.5032 525.4686)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 236.6477 526.9443)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 218.8445 535.3797)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 209.986 528.2593)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 297.2784 548.6835)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 311.1337 533.3001)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 308.0958 527.2593)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 295.5671 513.5901)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 315.1337 489.1139)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 311.3452 489.1139)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 278.5905 488.1139)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 272.3551 496.7012)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 318.2914 541.6473)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 256.0092 459.864)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 250.1647 494.7245)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 229.2912 489.7451)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 204.1321 501.7551)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 203.7302 490.588)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 249.7381 475.5796)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 215.151 473.7834)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 203.7302 471.5796)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 273.8696 456.8873)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 293.9626 456.1431)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 283.4605 444.2134)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 308.7016 455.5972)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 302.5002 449.3129)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 170.992 503.2608)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 174.992 493.5681)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 149.2187 533.9104)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 132.1446 516.6401)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 134.3982 500.0887)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 176.0178 460.5114)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 140.3337 464.7726)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 144.5319 455.1431)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 137.1505 449.6315)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 284.4605 411.5964)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 276.727 426.0375)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 231.5338 426.6689)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 221.9627 427.6955)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 205.1221 429.1595)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 252.0092 404.0299)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 269.0324 426.3757)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 205.1604 410.0162)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 169.4496 410.2078)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 274.2621 394.3265)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 174.8171 413.5168)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 153.4346 406.2078)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 146.6141 416.3293)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 146.2287 409.2078)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 136.1505 407.8917)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 143.5319 386.1049)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 315.161 385.0256)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 303.7245 382.1356)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 310.2021 346.9365)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 291.5051 377.4097)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 306.1016 396.9454)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 312.3673 404.338)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 256.7434 375.5298)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 264.4612 362.0195)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 308.1686 409.4032)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 272.8868 300.2083)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 287.8543 330.3317)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 259.5277 332.1446)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 271.5799 320.5677)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 299.266 302.243)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 398.2873 625.5765)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 393.1017 622.6544)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 429.0279 599.0333)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 411.7985 601.9919)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 410.5957 618.6544)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 419.7137 612.7009)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 435.4205 587.4229)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 418.1309 595.6107)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 412.6039 589.1759)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 420.8542 580.8854)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 412.6039 578.6537)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 437.1846 576.4105)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 439.4205 570.6537)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 428.3362 569.8751)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 409.5957 549.4895)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 413.6191 564.3442)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 383.2173 583.769)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 383.6068 568.8751)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 392.3414 547.6778)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 401.5361 559.5832)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 445.3622 540.7762)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 422.0754 545.3162)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 416.2921 514.4919)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 437.9619 533.099)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 418.193 536.0499)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 432.8296 519.5687)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 398.5055 537.9954)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 445.2486 515.0909)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 442.6166 510.0909)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 422.9451 504.7878)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 429.5137 489.7522)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 422.9451 482.3127)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 433.9034 465.0147)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 408.9785 464.0147)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 413.4409 460.0147)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 399.5055 460.4579)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 388.9198 450.1896)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 419.7137 445.9075)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 439.8074 439.1458)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 436.8422 434.3088)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 427.52 438.1458)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 427.6973 415.9405)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 430.5137 405.6031)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 380.5561 429.6533)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 389.5436 430.3088)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 394.921 399.9125)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 415.5318 393.527)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 380.6741 408.0332)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 405.8374 378.8303)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 375.8039 381.5012)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 371.2012 396.8687)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 374.0932 362.1854)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 360.8247 369.9841)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 363.2168 352.6192)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 405.2672 328.6743)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 380.2868 322.9771)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 380.4214 306.3382)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 359.8247 314.8409)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 349.6902 341.4162)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 324.5185 305.3382)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 341.8288 359.1864)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 343.7565 339.448)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 345.6902 331.3358)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 336.0703 327.822)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 341.9895 318.2368)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 343.2643 309.3382)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 311.2021 287.6122)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 328.6651 317.4457)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 328.6651 326.2526)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 309.2021 315.8409)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 382.4586 285.6992)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 371.1561 286.5716)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 309.4266 271.4663)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 375.1561 280.3153)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 354.3495 287.974)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 348.3529 260.7658)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 332.0703 259.304)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 378.275 254.5409)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 367.0447 259.304)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 371.7809 245.1296)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 359.6976 249.4818)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 364.9691 234.772)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 344.5401 218.3798)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 335.0703 229.7236)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 333.2547 222.9678)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 313.7422 247.5822)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 313.7422 243.5822)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 63.834 622.155)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 63.2766 605.6879)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 46.338 617.0731)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 51.7587 608.9451)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 55.7587 601.4088)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 54.0226 594.6279)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 46.338 591.7175)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 35.2231 601.3912)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 59.9085 580.5065)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 39.8235 580.7203)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 49.003 580.5065)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 33.1469 580.6357)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 37.4547 552.0208)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 50.1464 563.3827)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 46.338 554.0698)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 41.3783 561.9568)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 65.2014 559.6168)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 73.5803 547.6778)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 60.8706 558.1104)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 55.5268 547.7476)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 63.0683 541.7883)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 67.7816 537.3866)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 43.0808 526.1458)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 49.1464 525.2419)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 74.4099 524.2593)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 67.5796 505.5105)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 79.2087 512.7435)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 66.5796 501.7806)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 86.017 496.143)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 110.2981 478.2826)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 122.3558 469.0517)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 62.2768 485.0966)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 103.081 492.985)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 102.5992 475.7378)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 75.9492 473.8175)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 96.0848 472.5152)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 107.9292 460.1129)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 80.6649 430.6689)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 90.6702 452.1478)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 129.3776 453.1701)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 74.8389 456.1129)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 133.3062 439.0269)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 123.6259 418.7461)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 92.3006 420.3293)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 100.8656 408.4223)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 119.2622 406.4653)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 115.6355 393.101)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 102.2266 393.0502)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 107.0896 380.1488)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 124.6259 381.9738)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 133.3776 374.0226)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 110.7423 368.3154)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 118.5893 366.0195)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 227.0405 348.5092)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 206.8011 350.841)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 220.376 333.0849)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 230.6298 324.8937)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 199.9438 341.3536)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 179.5108 341.4579)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 146.7995 338.0327)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 171.2496 369.3075)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 166.2149 375.9236)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 169.7049 336.8966)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 159.6547 350.841)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 169.7049 352.7269)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 123.4449 339.528)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 153.0153 373.8413)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 126.5725 343.528)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 144.1673 368.4822)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 175.1466 329.9803)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 161.3928 329.9803)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 148.1673 328.0156)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 125.0532 324.332)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 181.8725 307.3715)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 146.6448 318.3723)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 158.6547 306.2172)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 150.6448 303.106)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 145.1673 307.6727)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 133.2556 311.1244)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 136.1606 300.5561)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 125.8131 306.2104)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 126.0532 299.5561)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 167.0098 281.1785)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 231.5552 301.243)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 223.7768 290.0264)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 154.6448 283.0415)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 142.0722 278.5667)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 147.1673 273.5886)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 130.0532 276.1919)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 130.5725 267.7028)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 152.6498 236.2696)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 141.0722 247.8277)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 164.7357 263.049)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 146.7995 253.7513)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 183.5108 274.0203)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 184.4967 267.7028)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 223.1532 266.0975)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 213.6929 266.2447)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 189.4226 237.2696)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 259.9389 304.4203)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 275.2075 271.2729)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 251.8146 276.4452)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 250.3108 273.6757)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 252.221 299.829)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 187.9715 235.2696)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 214.1211 232.5449)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 272.9202 234.2696)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 269.9425 218.4307)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 234.5949 229.5)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 281.6027 216.4489)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 304.5748 218.297)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 224.6755 209.6795)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 311.5655 206.6795)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 332.0493 208.2296)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 317.0675 196.7549)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 270.263 198.0745)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 249.0243 210.6795)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 277.4111 181.4029)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 201.0736 215.7721)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 199.5507 205.7494)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 218.5031 205.8261)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 222.5031 191.0514)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 199.5947 200.4161)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 277.6979 171.8242)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 271.4897 176.5242)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 261.433 181.003)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 245.0243 186.571)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 240.2364 180.4029)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 246.3994 168.5059)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 253.0849 158.0136)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 230.5918 168.9764)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 223.6755 178.0685)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 273.09 148.4128)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 207.1993 189.732)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 230.8774 152.5393)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 212.4134 179.0685)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 272.8868 140.5479)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 208.7182 170.6956)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 203.1993 162.3086)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 206.8661 153.4792)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 220.6755 148.6161)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 212.7182 146.744)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 244.0243 133.5752)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 198.5507 151.5393)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 262.1464 122.8568)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 281.4427 115.4519)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 194.5507 118.1459)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 231.2039 120.9439)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 199.5507 126.3541)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 215.1523 116.0442)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 265.0135 109.206)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 187.8094 118.1459)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 253.151 105.6804)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 271.2989 103.1303)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 281.6311 88.9012)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 238.8122 91.9012)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 259.2639 81.6476)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 212.9826 97.7054)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 223.538 69.1444)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 231.9981 77.6476)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 188.7102 83.3235)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 271.8563 62.8965)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 202.09 83.5162)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 255.9683 70.8575)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 256.353 55.137)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 253.0867 49.0101)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 248.1655 56.0674)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 234.9269 49.8824)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 225.8301 53.0101)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 213.2801 56.6485)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 200.9374 61.8965)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 229.8301 44.51)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dot",
    width: 8,
    height: 8,
    x: -4,
    y: -4,
    transform: "matrix(1 0 0 -1 220.3198 47.1607)",
    style: {
      overflow: "visible"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireframeMan);
export default __webpack_public_path__ + "static/media/wireframe-man.21d5dd52e917a9bbeb09056d9b2a4e3f.svg";
export { ForwardRef as ReactComponent };